var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurface(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 64,
    viewBox: "0 0 751 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.841 8.7793L405.622 25.7064L403.819 24.2633L428.032 11.1762L429.841 8.7793Z",
    stroke: "url(#paint0_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.622 25.7068L381.409 48.1523L379.606 48.3691L403.819 24.2637L405.622 25.7068Z",
    stroke: "url(#paint1_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.644 6.04883L407.431 27.0451L405.622 25.7073L429.841 8.7802L431.644 6.04883Z",
    stroke: "url(#paint2_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.446 3.01953L409.234 28.246L407.431 27.0445L431.643 6.04819L433.446 3.01953Z",
    stroke: "url(#paint3_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M407.431 27.0448L383.218 47.7376L381.409 48.1526L405.622 25.707L407.431 27.0448Z",
    stroke: "url(#paint4_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.25 -0.255859L411.037 29.269L409.234 28.247L433.447 3.02055L435.25 -0.255859Z",
    stroke: "url(#paint5_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M409.234 28.2465L385.022 47.1307L383.219 47.7377L407.431 27.0449L409.234 28.2465Z",
    stroke: "url(#paint6_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M437.059 -1.32227L412.846 30.0916L411.037 29.2678L435.25 -0.256968L437.059 -1.32227Z",
    stroke: "url(#paint7_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M411.037 29.268L386.824 46.3314L385.021 47.1303L409.234 28.2461L411.037 29.268Z",
    stroke: "url(#paint8_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 -21.3262L438.862 0.382338L437.059 -1.3209L461.271 -18.5762L463.074 -21.3262Z",
    stroke: "url(#paint9_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438.861 0.38097L414.649 30.6862L412.846 30.0916L437.058 -1.32227L438.861 0.38097Z",
    stroke: "url(#paint10_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M412.846 30.0913L388.627 45.3337L386.824 46.3309L411.037 29.2676L412.846 30.0913Z",
    stroke: "url(#paint11_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M464.883 -24.2246L440.664 1.86276L438.861 0.382496L463.074 -21.326L464.883 -24.2246Z",
    stroke: "url(#paint12_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M657.841 -8.79697L633.628 -0.386078L631.825 -3.87307L656.038 -11.9805L657.841 -8.79697Z",
    stroke: "url(#paint13_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M713.49 -21.3705L689.278 0.499055L687.469 -2.27567L711.687 -23.6621L713.49 -21.3705Z",
    stroke: "url(#paint14_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M440.664 1.86113L416.451 31.0205L414.648 30.6861L438.861 0.380859L440.664 1.86113Z",
    stroke: "url(#paint15_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M414.649 30.6864L390.436 44.1326L388.627 45.3342L412.846 30.0918L414.649 30.6864Z",
    stroke: "url(#paint16_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M659.65 -5.56382L635.431 2.85326L633.628 -0.385986L657.84 -8.79688L659.65 -5.56382Z",
    stroke: "url(#paint17_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M466.686 -27.2363L442.473 3.08126L440.664 1.86113L464.883 -24.2262L466.686 -27.2363Z",
    stroke: "url(#paint18_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M687.469 -2.27556L663.256 1.01324L661.453 -2.28795L685.666 -5.16797L687.469 -2.27556Z",
    stroke: "url(#paint19_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M715.293 -19.29L691.08 3.12453L689.277 0.498455L713.49 -21.3711L715.293 -19.29Z",
    stroke: "url(#paint20_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M362.612 53.7266L338.399 74.4317L336.59 74.5556L360.809 56.043L362.612 53.7266Z",
    stroke: "url(#paint21_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M442.474 3.08146L418.261 31.0517L416.452 31.0207L440.665 1.86133L442.474 3.08146Z",
    stroke: "url(#paint22_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M661.452 -2.28805L637.24 5.81316L635.431 2.85262L659.649 -5.56445L661.452 -2.28805Z",
    stroke: "url(#paint23_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M468.489 -30.2949L444.277 3.97418L442.474 3.0823L466.686 -27.2353L468.489 -30.2949Z",
    stroke: "url(#paint24_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M416.452 31.022L392.239 42.7216L390.437 44.1338L414.649 30.6875L416.452 31.022Z",
    stroke: "url(#paint25_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M689.278 0.499337L665.059 4.32697L663.256 1.0134L687.468 -2.27539L689.278 0.499337Z",
    stroke: "url(#paint26_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M633.628 -0.385773L609.416 -3.09237L607.606 -6.62891L631.825 -3.87276L633.628 -0.385773Z",
    stroke: "url(#paint27_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M717.096 -17.4558L692.883 5.56579L691.08 3.12552L715.293 -19.2891L717.096 -17.4558Z",
    stroke: "url(#paint28_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M364.415 51.293L340.202 74.2836L338.399 74.4322L362.612 53.7271L364.415 51.293Z",
    stroke: "url(#paint29_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M444.276 3.97391L420.064 30.7488L418.261 31.0523L442.473 3.08203L444.276 3.97391Z",
    stroke: "url(#paint30_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M663.256 1.01407L639.043 8.45256L637.24 5.81409L661.453 -2.28711L663.256 1.01407Z",
    stroke: "url(#paint31_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M691.08 3.12608L666.868 7.64739L665.059 4.32764L689.277 0.5L691.08 3.12608Z",
    stroke: "url(#paint32_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M470.298 -33.3496L446.079 4.49319L444.276 3.97293L468.489 -30.2962L470.298 -33.3496Z",
    stroke: "url(#paint33_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M635.431 2.85209L611.218 0.238396L609.415 -3.09375L633.628 -0.387153L635.431 2.85209Z",
    stroke: "url(#paint34_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M718.905 -15.9067L694.692 7.78377L692.883 5.56647L717.096 -17.4551L718.905 -15.9067Z",
    stroke: "url(#paint35_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M366.218 48.7656L342.005 74.1284L340.202 74.2832L364.415 51.2926L366.218 48.7656Z",
    stroke: "url(#paint36_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M665.059 4.32725L640.846 10.7252L639.043 8.45217L663.256 1.01367L665.059 4.32725Z",
    stroke: "url(#paint37_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M446.079 4.49487L421.866 30.0558L420.063 30.7495L444.276 3.97461L446.079 4.49487Z",
    stroke: "url(#paint38_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M692.884 5.56528L668.671 10.8856L666.868 7.64632L691.081 3.125L692.884 5.56528Z",
    stroke: "url(#paint39_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M637.24 5.81251L613.022 3.31649L611.219 0.238281L635.431 2.85197L637.24 5.81251Z",
    stroke: "url(#paint40_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M472.101 -36.334L447.888 4.58083L446.079 4.49412L470.298 -33.3487L472.101 -36.334Z",
    stroke: "url(#paint41_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M720.708 -14.6881L696.495 9.59698L694.692 7.78225L718.905 -15.9082L720.708 -14.6881Z",
    stroke: "url(#paint42_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M368.027 48.4941L343.814 73.9932L342.005 74.1294L366.217 48.7667L368.027 48.4941Z",
    stroke: "url(#paint43_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M666.867 7.64592L642.655 12.7618L640.846 10.7241L665.058 4.32617L666.867 7.64592Z",
    stroke: "url(#paint44_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M694.693 7.7837L670.474 13.7172L668.671 10.8867L692.883 5.56641L694.693 7.7837Z",
    stroke: "url(#paint45_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M639.043 8.4509L614.824 6.09733L613.021 3.31641L637.24 5.81242L639.043 8.4509Z",
    stroke: "url(#paint46_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M447.889 4.58085L423.67 28.934L421.867 30.0551L446.08 4.49414L447.889 4.58085Z",
    stroke: "url(#paint47_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M722.511 -13.808L698.298 10.9725L696.495 9.59755L720.708 -14.6875L722.511 -13.808Z",
    stroke: "url(#paint48_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M473.904 -39.1895L449.692 4.17803L447.889 4.58061L472.101 -36.3342L473.904 -39.1895Z",
    stroke: "url(#paint49_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M611.218 0.239426L587.005 -6.3939L585.196 -9.62695L609.415 -3.09272L611.218 0.239426Z",
    stroke: "url(#paint50_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M369.83 48.9153L345.617 73.8135L343.814 73.9931L368.027 48.4941L369.83 48.9153Z",
    stroke: "url(#paint51_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M668.671 10.8857L644.458 14.8682L642.655 12.7624L666.868 7.64648L668.671 10.8857Z",
    stroke: "url(#paint52_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M696.495 9.59793L672.283 16.1012L670.474 13.7167L694.692 7.7832L696.495 9.59793Z",
    stroke: "url(#paint53_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M640.846 10.7243L616.633 8.79187L614.824 6.09766L639.043 8.45122L640.846 10.7243Z",
    stroke: "url(#paint54_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M449.692 4.17773L425.479 27.3293L423.67 28.9335L447.889 4.58032L449.692 4.17773Z",
    stroke: "url(#paint55_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M724.32 -13.2326L700.107 11.9505L698.298 10.9719L722.511 -13.8086L724.32 -13.2326Z",
    stroke: "url(#paint56_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M613.021 3.31702L588.809 -3.22341L587.006 -6.39453L611.218 0.238802L613.021 3.31702Z",
    stroke: "url(#paint57_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M475.707 -40.0742L451.494 3.22513L449.691 4.17894L473.904 -39.1885L475.707 -40.0742Z",
    stroke: "url(#paint58_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M670.474 13.7172L646.261 17.0246L644.458 14.8692L668.671 10.8867L670.474 13.7172Z",
    stroke: "url(#paint59_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M371.633 49.329L347.42 73.4221L345.617 73.8123L369.83 48.9141L371.633 49.329Z",
    stroke: "url(#paint60_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M698.299 10.9726L674.086 18.0581L672.283 16.1009L696.496 9.59766L698.299 10.9726Z",
    stroke: "url(#paint61_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M642.656 12.7631L618.437 11.4996L616.634 8.79297L640.846 10.7254L642.656 12.7631Z",
    stroke: "url(#paint62_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M726.123 -12.9104L701.91 12.5886L700.107 11.9507L724.32 -13.2324L726.123 -12.9104Z",
    stroke: "url(#paint63_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M614.824 6.09868L590.612 -0.163026L588.809 -3.22266L613.021 3.31776L614.824 6.09868Z",
    stroke: "url(#paint64_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M451.494 3.22461L427.281 25.2614L425.479 27.33L449.691 4.17842L451.494 3.22461Z",
    stroke: "url(#paint65_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M477.516 -41.0352L453.297 1.66342L451.494 3.2242L475.707 -40.0752L477.516 -41.0352Z",
    stroke: "url(#paint66_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M672.282 16.1013L648.07 19.2229L646.261 17.0242L670.473 13.7168L672.282 16.1013Z",
    stroke: "url(#paint67_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M644.458 14.8693L620.239 14.219L618.437 11.5L642.655 12.7635L644.458 14.8693Z",
    stroke: "url(#paint68_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M700.108 11.9512L675.889 19.6127L674.086 18.0581L698.299 10.9727L700.108 11.9512Z",
    stroke: "url(#paint69_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M373.442 49.6521L349.229 72.8533L347.42 73.4231L371.633 49.3301L373.442 49.6521Z",
    stroke: "url(#paint70_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M616.633 8.79185L592.42 2.7655L590.611 -0.164062L614.824 6.09764L616.633 8.79185Z",
    stroke: "url(#paint71_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M727.926 -12.7987L703.713 12.9171L701.91 12.5888L726.123 -12.9102L727.926 -12.7987Z",
    stroke: "url(#paint72_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M479.319 -42.4727L455.106 -0.294341L453.297 1.66283L477.516 -41.0357L479.319 -42.4727Z",
    stroke: "url(#paint73_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M674.086 18.0587L649.873 21.4342L648.07 19.2231L672.283 16.1016L674.086 18.0587Z",
    stroke: "url(#paint74_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M646.261 17.0244L622.048 16.9501L620.239 14.2188L644.458 14.8691L646.261 17.0244Z",
    stroke: "url(#paint75_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M701.91 12.5891L677.698 20.7894L675.889 19.6126L700.107 11.9512L701.91 12.5891Z",
    stroke: "url(#paint76_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M375.245 49.801L351.032 72.1351L349.229 72.8535L373.442 49.6523L375.245 49.801Z",
    stroke: "url(#paint77_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M618.436 11.4986L594.224 5.52796L592.421 2.76562L616.634 8.79199L618.436 11.4986Z",
    stroke: "url(#paint78_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M729.735 -12.8594L705.516 12.9803L703.713 12.9183L727.926 -12.7974L729.735 -12.8594Z",
    stroke: "url(#paint79_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M590.611 -0.162972L566.399 -5.89823L564.596 -8.36328L588.808 -3.2226L590.611 -0.162972Z",
    stroke: "url(#paint80_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M675.889 19.6132L651.676 23.639L649.873 21.4341L674.086 18.0586L675.889 19.6132Z",
    stroke: "url(#paint81_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M648.071 19.2223L623.852 19.6744L622.049 16.9492L646.261 17.0235L648.071 19.2223Z",
    stroke: "url(#paint82_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M703.713 12.9181L679.5 21.6139L677.697 20.7901L701.91 12.5898L703.713 12.9181Z",
    stroke: "url(#paint83_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M377.048 49.807L352.835 72.4446L351.032 72.1349L375.245 49.8008L377.048 49.807Z",
    stroke: "url(#paint84_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M620.239 14.2189L596.027 8.11202L594.224 5.5293L618.436 11.4999L620.239 14.2189Z",
    stroke: "url(#paint85_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M731.538 -13.0586L707.325 12.8058L705.516 12.9792L729.735 -12.8604L731.538 -13.0586Z",
    stroke: "url(#paint86_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M592.421 2.76639L568.202 -3.5201L566.399 -5.89844L590.612 -0.163176L592.421 2.76639Z",
    stroke: "url(#paint87_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M677.698 20.7901L653.479 25.8131L651.676 23.6391L675.888 19.6133L677.698 20.7901Z",
    stroke: "url(#paint88_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M649.873 21.4338L625.661 22.3752L623.852 19.6748L648.07 19.2227L649.873 21.4338Z",
    stroke: "url(#paint89_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M705.517 12.9799L681.304 22.1154L679.501 21.6138L703.714 12.918L705.517 12.9799Z",
    stroke: "url(#paint90_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M378.857 49.6816L354.644 73.9357L352.835 72.4431L377.048 49.8055L378.857 49.6816Z",
    stroke: "url(#paint91_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M622.048 16.9496L597.835 10.4959L596.026 8.11133L620.239 14.2182L622.048 16.9496Z",
    stroke: "url(#paint92_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M404.872 27.4102L380.659 49.4593L378.856 49.6823L403.069 29.2497L404.872 27.4102Z",
    stroke: "url(#paint93_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M594.224 5.5293L570.011 -1.24648L568.202 -3.51953L592.421 2.76696L594.224 5.5293Z",
    stroke: "url(#paint94_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M733.341 -13.3809L709.128 12.434L707.325 12.8056L731.538 -13.0588L733.341 -13.3809Z",
    stroke: "url(#paint95_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M651.676 23.6385L627.463 25.0259L625.66 22.375L649.873 21.4336L651.676 23.6385Z",
    stroke: "url(#paint96_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M679.5 21.6128L655.288 27.9179L653.479 25.8121L677.697 20.7891L679.5 21.6128Z",
    stroke: "url(#paint97_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M707.325 12.8066L683.113 22.32L681.304 22.1156L705.516 12.9801L707.325 12.8066Z",
    stroke: "url(#paint98_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M623.852 19.675L599.639 12.6824L597.836 10.4961L622.049 16.9498L623.852 19.675Z",
    stroke: "url(#paint99_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M380.66 49.459L356.447 75.2986L354.645 73.936L378.857 49.682L380.66 49.459Z",
    stroke: "url(#paint100_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M406.675 27.6703L382.462 50.0849L380.659 49.4593L404.872 27.4102L406.675 27.6703Z",
    stroke: "url(#paint101_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M596.026 8.11047L571.814 0.90732L570.011 -1.24805L594.223 5.52774L596.026 8.11047Z",
    stroke: "url(#paint102_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M653.479 25.8126L629.266 27.6026L627.463 25.026L651.676 23.6387L653.479 25.8126Z",
    stroke: "url(#paint103_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M681.304 22.115L657.091 29.9251L655.288 27.9184L679.501 21.6133L681.304 22.115Z",
    stroke: "url(#paint104_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M735.15 -13.7832L710.931 11.883L709.128 12.4342L733.341 -13.3806L735.15 -13.7832Z",
    stroke: "url(#paint105_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M625.66 22.3746L601.442 14.6698L599.639 12.6816L623.851 19.6742L625.66 22.3746Z",
    stroke: "url(#paint106_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M382.463 50.0845L358.25 76.494L356.447 75.2986L380.66 49.459L382.463 50.0845Z",
    stroke: "url(#paint107_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M709.128 12.4336L684.915 22.2628L683.112 22.3185L707.325 12.8052L709.128 12.4336Z",
    stroke: "url(#paint108_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M408.485 27.8L384.272 51.6143L382.463 50.0845L406.675 27.6699L408.485 27.8Z",
    stroke: "url(#paint109_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M597.836 10.4959L573.617 2.92731L571.814 0.908203L596.027 8.11134L597.836 10.4959Z",
    stroke: "url(#paint110_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M655.288 27.9183L631.076 30.0799L629.267 27.6024L653.479 25.8125L655.288 27.9183Z",
    stroke: "url(#paint111_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M683.113 22.3196L658.894 31.802L657.091 29.9254L681.303 22.1152L683.113 22.3196Z",
    stroke: "url(#paint112_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M736.953 -14.2715L712.74 11.1903L710.931 11.884L735.15 -13.7822L736.953 -14.2715Z",
    stroke: "url(#paint113_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M627.463 25.0256L603.244 16.4475L601.441 14.6699L625.66 22.3747L627.463 25.0256Z",
    stroke: "url(#paint114_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M384.272 51.6158L360.053 77.4988L358.25 76.4954L382.463 50.0859L384.272 51.6158Z",
    stroke: "url(#paint115_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M710.932 11.8828L686.719 21.9722L684.916 22.2633L709.129 12.4341L710.932 11.8828Z",
    stroke: "url(#paint116_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M410.287 27.7949L386.074 53.04L384.271 51.6155L408.484 27.8011L410.287 27.7949Z",
    stroke: "url(#paint117_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M599.639 12.6826L575.426 4.80439L573.617 2.92773L597.836 10.4963L599.639 12.6826Z",
    stroke: "url(#paint118_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M657.091 29.9247L632.878 32.4207L631.075 30.0795L655.288 27.918L657.091 29.9247Z",
    stroke: "url(#paint119_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M684.915 22.2637L660.703 33.5112L658.894 31.8018L683.112 22.3194L684.915 22.2637Z",
    stroke: "url(#paint120_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M738.756 -14.8184L714.543 10.371L712.74 11.1885L736.953 -14.2733L738.756 -14.8184Z",
    stroke: "url(#paint121_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M629.266 27.6019L605.053 18.0266L603.244 16.4473L627.463 25.0254L629.266 27.6019Z",
    stroke: "url(#paint122_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M386.074 53.0398L361.862 78.2848L360.053 77.4982L384.272 51.6152L386.074 53.0398Z",
    stroke: "url(#paint123_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M712.74 11.1895L688.522 21.4832L686.719 21.9725L710.931 11.8831L712.74 11.1895Z",
    stroke: "url(#paint124_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M412.09 27.6582L387.877 54.3402L386.074 53.0395L410.287 27.7945L412.09 27.6582Z",
    stroke: "url(#paint125_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M601.441 14.6711L577.229 6.53269L575.426 4.80469L599.638 12.6829L601.441 14.6711Z",
    stroke: "url(#paint126_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M658.894 31.8024L634.682 34.6019L632.879 32.4218L657.092 29.9258L658.894 31.8024Z",
    stroke: "url(#paint127_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M686.719 21.9727L662.506 35.0225L660.703 33.5113L684.916 22.2638L686.719 21.9727Z",
    stroke: "url(#paint128_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M740.559 -15.4238L716.346 9.44962L714.543 10.3725L738.756 -14.8169L740.559 -15.4238Z",
    stroke: "url(#paint129_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M631.075 30.0801L606.857 19.4147L605.054 18.0273L629.266 27.6026L631.075 30.0801Z",
    stroke: "url(#paint130_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M387.878 54.3397L363.665 78.8416L361.862 78.2841L386.075 53.0391L387.878 54.3397Z",
    stroke: "url(#paint131_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 27.3984L389.681 55.5049L387.878 54.3405L412.091 27.6586L413.9 27.3984Z",
    stroke: "url(#paint132_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M714.543 10.3711L690.331 20.8073L688.521 21.4824L712.74 11.1886L714.543 10.3711Z",
    stroke: "url(#paint133_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M603.245 16.4472L579.032 8.09824L577.229 6.53125L601.442 14.6696L603.245 16.4472Z",
    stroke: "url(#paint134_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M660.703 33.5102L636.485 36.5884L634.682 34.6003L658.894 31.8008L660.703 33.5102Z",
    stroke: "url(#paint135_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M688.521 21.4824L664.309 36.2975L662.506 35.0216L686.718 21.9717L688.521 21.4824Z",
    stroke: "url(#paint136_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M632.878 32.4206L608.659 20.6218L606.856 19.4141L631.075 30.0794L632.878 32.4206Z",
    stroke: "url(#paint137_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M742.368 -16.0742L718.155 8.43378L716.346 9.44953L740.559 -15.4239L742.368 -16.0742Z",
    stroke: "url(#paint138_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M389.681 55.5042L365.468 79.1452L363.665 78.8417L387.878 54.3398L389.681 55.5042Z",
    stroke: "url(#paint139_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M415.702 27.002L391.49 56.5206L389.681 55.5048L413.899 27.3983L415.702 27.002Z",
    stroke: "url(#paint140_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M605.054 18.0279L580.835 9.51175L579.032 8.09961L603.245 16.4486L605.054 18.0279Z",
    stroke: "url(#paint141_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M662.506 35.0229L638.294 38.3489L636.484 36.5899L660.703 33.5117L662.506 35.0229Z",
    stroke: "url(#paint142_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M690.33 20.8086L666.118 37.3145L664.309 36.2988L688.521 21.4837L690.33 20.8086Z",
    stroke: "url(#paint143_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M634.681 34.602L610.468 21.6698L608.659 20.623L632.878 32.4218L634.681 34.602Z",
    stroke: "url(#paint144_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M744.171 -16.7871L719.958 7.3369L718.155 8.43316L742.368 -16.0748L744.171 -16.7871Z",
    stroke: "url(#paint145_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M391.49 56.5197L367.277 79.1882L365.468 79.1448L389.68 55.5039L391.49 56.5197Z",
    stroke: "url(#paint146_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M664.309 36.2974L640.096 39.8525L638.293 38.3474L662.506 35.0215L664.309 36.2974Z",
    stroke: "url(#paint147_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M417.505 26.4805L393.292 57.3803L391.489 56.5194L415.702 27.0007L417.505 26.4805Z",
    stroke: "url(#paint148_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M606.857 19.4153L582.644 10.769L580.835 9.51172L605.054 18.0279L606.857 19.4153Z",
    stroke: "url(#paint149_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M692.134 19.9902L667.921 38.0383L666.118 37.3137L690.331 20.8078L692.134 19.9902Z",
    stroke: "url(#paint150_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M745.974 -17.543L721.761 6.17227L719.958 7.33666L744.171 -16.7874L745.974 -17.543Z",
    stroke: "url(#paint151_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M393.293 57.3804L369.08 78.9589L367.277 79.1881L391.49 56.5195L393.293 57.3804Z",
    stroke: "url(#paint152_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M666.118 37.3146L641.9 41.0741L640.097 39.8539L664.309 36.2988L666.118 37.3146Z",
    stroke: "url(#paint153_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M608.66 20.6216L584.447 11.87L582.645 10.7676L606.857 19.4138L608.66 20.6216Z",
    stroke: "url(#paint154_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M419.315 25.8242L395.096 58.068L393.293 57.3805L417.506 26.4807L419.315 25.8242Z",
    stroke: "url(#paint155_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M719.958 7.33789L695.746 19.3287L693.937 19.1181L718.155 8.43416L719.958 7.33789Z",
    stroke: "url(#paint156_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M693.936 19.1172L669.724 38.4474L667.921 38.0386L692.134 19.9905L693.936 19.1172Z",
    stroke: "url(#paint157_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M667.921 38.0391L643.709 41.9906L641.899 41.074L666.118 37.3145L667.921 38.0391Z",
    stroke: "url(#paint158_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M395.096 58.0683L370.883 78.4638L369.08 78.9593L393.293 57.3809L395.096 58.0683Z",
    stroke: "url(#paint159_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M747.783 -18.3672L723.564 4.94547L721.761 6.1718L745.974 -17.5434L747.783 -18.3672Z",
    stroke: "url(#paint160_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M421.117 25.0391L396.905 58.5835L395.096 58.0695L419.315 25.8257L421.117 25.0391Z",
    stroke: "url(#paint161_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M721.761 6.17188L697.549 19.2032L695.746 19.327L719.958 7.33626L721.761 6.17188Z",
    stroke: "url(#paint162_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M695.745 19.3278L671.527 38.5155L669.724 38.4474L693.936 19.1172L695.745 19.3278Z",
    stroke: "url(#paint163_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M447.133 -4.13281L422.92 24.1161L421.117 25.039L445.33 -3.29668L447.133 -4.13281Z",
    stroke: "url(#paint164_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M669.724 38.4478L645.511 42.5728L643.708 41.9906L667.921 38.0391L669.724 38.4478Z",
    stroke: "url(#paint165_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M422.92 24.1152L398.707 58.917L396.904 58.5825L421.117 25.0381L422.92 24.1152Z",
    stroke: "url(#paint166_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M396.905 58.5824L372.692 77.6958L370.883 78.4638L395.095 58.0684L396.905 58.5824Z",
    stroke: "url(#paint167_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M749.586 -19.2578L725.373 3.66464L723.564 4.94671L747.783 -18.3659L749.586 -19.2578Z",
    stroke: "url(#paint168_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M723.564 4.94531L699.352 18.7384L697.549 19.2029L721.761 6.17164L723.564 4.94531Z",
    stroke: "url(#paint169_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M697.549 19.2031L673.336 38.2236L671.527 38.5147L695.746 19.327L697.549 19.2031Z",
    stroke: "url(#paint170_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M448.942 -4.93164L424.729 23.0572L422.92 24.1163L447.132 -4.13267L448.942 -4.93164Z",
    stroke: "url(#paint171_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M671.527 38.5154L647.315 42.8137L645.512 42.5722L669.724 38.4473L671.527 38.5154Z",
    stroke: "url(#paint172_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M424.729 23.0566L400.51 59.0723L398.707 58.9175L422.92 24.1157L424.729 23.0566Z",
    stroke: "url(#paint173_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M398.708 58.9165L374.495 76.6611L372.692 77.6954L396.905 58.582L398.708 58.9165Z",
    stroke: "url(#paint174_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M751.389 -20.2305L727.176 2.32656L725.373 3.66438L749.586 -19.2581L751.389 -20.2305Z",
    stroke: "url(#paint175_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M699.352 18.7402L675.139 37.5749L673.336 38.2253L697.549 19.2048L699.352 18.7402Z",
    stroke: "url(#paint176_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M725.373 3.66406L701.161 17.9155L699.352 18.7392L723.564 4.94613L725.373 3.66406Z",
    stroke: "url(#paint177_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M450.745 -5.92383L426.532 21.8606L424.729 23.0559L448.942 -4.93286L450.745 -5.92383Z",
    stroke: "url(#paint178_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M673.336 38.2246L649.124 42.7026L647.314 42.814L671.527 38.5157L673.336 38.2246Z",
    stroke: "url(#paint179_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M426.532 21.8613L402.32 59.0476L400.511 59.0724L424.73 23.0567L426.532 21.8613Z",
    stroke: "url(#paint180_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M400.511 59.0728L376.298 75.3743L374.495 76.6626L398.708 58.918L400.511 59.0728Z",
    stroke: "url(#paint181_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M753.198 -21.2891L728.979 0.927321L727.176 2.32707L751.389 -20.23L753.198 -21.2891Z",
    stroke: "url(#paint182_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M701.16 17.916L676.942 36.5463L675.139 37.5745L699.351 18.7398L701.16 17.916Z",
    stroke: "url(#paint183_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M452.548 -7.11328L428.335 20.5225L426.532 21.8603L450.745 -5.92411L452.548 -7.11328Z",
    stroke: "url(#paint184_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M428.335 20.5234L404.122 58.8493L402.319 59.0475L426.532 21.8612L428.335 20.5234Z",
    stroke: "url(#paint185_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M402.32 59.0469L378.101 73.8433L376.298 75.3732L400.51 59.0716L402.32 59.0469Z",
    stroke: "url(#paint186_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M755.001 -22.4609L730.788 -0.529463L728.979 0.926029L753.198 -21.2904L755.001 -22.4609Z",
    stroke: "url(#paint187_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M702.963 16.7324L678.75 35.1522L676.941 36.5457L701.16 17.9154L702.963 16.7324Z",
    stroke: "url(#paint188_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M454.357 -8.49414L430.138 21.2846L428.335 20.5228L452.548 -7.11297L454.357 -8.49414Z",
    stroke: "url(#paint189_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M430.138 21.2852L405.925 58.4777L404.122 58.8493L428.335 20.5234L430.138 21.2852Z",
    stroke: "url(#paint190_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M456.159 -10.0723L431.947 22.2582L430.138 21.2858L454.357 -8.49291L456.159 -10.0723Z",
    stroke: "url(#paint191_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M431.947 22.2575L407.735 57.9388L405.926 58.4776L430.138 21.2852L431.947 22.2575Z",
    stroke: "url(#paint192_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M457.963 -11.8379L433.75 23.1125L431.947 22.2578L456.16 -10.0727L457.963 -11.8379Z",
    stroke: "url(#paint193_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M433.75 23.1125L409.537 57.2392L407.734 57.9391L431.947 22.2578L433.75 23.1125Z",
    stroke: "url(#paint194_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M459.772 -13.7832L435.553 23.8428L433.75 23.112L457.963 -11.8384L459.772 -13.7832Z",
    stroke: "url(#paint195_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M435.553 23.8422L411.34 56.3833L409.537 57.238L433.75 23.1113L435.553 23.8422Z",
    stroke: "url(#paint196_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M461.574 -15.9023L437.362 24.4179L435.553 23.8419L459.772 -13.7841L461.574 -15.9023Z",
    stroke: "url(#paint197_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M437.363 24.4197L413.15 55.3815L411.341 56.3848L435.553 23.8438L437.363 24.4197Z",
    stroke: "url(#paint198_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M463.378 -18.168L439.165 24.8279L437.362 24.4191L461.575 -15.9011L463.378 -18.168Z",
    stroke: "url(#paint199_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M439.165 24.8267L414.952 54.2339L413.149 55.3797L437.362 24.418L439.165 24.8267Z",
    stroke: "url(#paint200_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M465.187 -18.8184L440.968 25.0508L439.165 24.8278L463.378 -18.168L465.187 -18.8184Z",
    stroke: "url(#paint201_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M440.968 25.0511L416.755 52.9532L414.952 54.2353L439.165 24.8281L440.968 25.0511Z",
    stroke: "url(#paint202_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M466.99 -16.2914L442.777 25.0632L440.968 25.0508L465.187 -18.8184L466.99 -16.2914Z",
    stroke: "url(#paint203_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M442.778 25.0632L418.559 51.5469L416.756 52.9529L440.968 25.0508L442.778 25.0632Z",
    stroke: "url(#paint204_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M468.793 -11.4848L444.58 24.8282L442.777 25.0636L466.99 -16.291L468.793 -11.4848Z",
    stroke: "url(#paint205_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M444.58 24.8281L420.368 49.9927L418.559 51.5472L442.777 25.0635L444.58 24.8281Z",
    stroke: "url(#paint206_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M470.596 -6.88254L446.383 24.3207L444.58 24.8286L468.793 -11.4844L470.596 -6.88254Z",
    stroke: "url(#paint207_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M446.383 24.3203L422.17 47.9984L420.367 49.9927L444.58 24.8282L446.383 24.3203Z",
    stroke: "url(#paint208_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M472.405 -2.52872L448.186 26.0175L446.383 24.3205L470.595 -6.88281L472.405 -2.52872Z",
    stroke: "url(#paint209_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M498.42 -19.4139L474.207 1.53275L472.404 -2.53024L496.617 -23.9043L498.42 -19.4139Z",
    stroke: "url(#paint210_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M581.895 1.0323L557.676 -1.01159L555.873 -4.81445L580.086 -0.968236L581.895 1.0323Z",
    stroke: "url(#paint211_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M474.207 1.53369L449.995 29.2995L448.186 26.0169L472.404 -2.5293L474.207 1.53369Z",
    stroke: "url(#paint212_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M448.186 26.0174L423.974 45.5024L422.171 47.9984L446.383 24.3203L448.186 26.0174Z",
    stroke: "url(#paint213_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M500.224 -14.8184L476.011 5.34169L474.208 1.53264L498.421 -19.4141L500.224 -14.8184Z",
    stroke: "url(#paint214_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M694.99 13.8828L670.777 22.9936L668.975 23.1298L693.187 14.626L694.99 13.8828Z",
    stroke: "url(#paint215_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M555.873 -4.81445L531.66 1.45965L529.857 -2.99354L554.07 -8.75977L555.873 -4.81445Z",
    stroke: "url(#paint216_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M583.698 2.89024L559.485 2.5434L557.676 -1.01172L581.895 1.03217L583.698 2.89024Z",
    stroke: "url(#paint217_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M476.011 5.34226L451.798 32.1853L449.995 29.299L474.208 1.5332L476.011 5.34226Z",
    stroke: "url(#paint218_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M502.032 -10.136L477.82 8.98358L476.011 5.34176L500.223 -14.8184L502.032 -10.136Z",
    stroke: "url(#paint219_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M449.995 29.3002L425.783 42.5483L423.974 45.5026L448.186 26.0176L449.995 29.3002Z",
    stroke: "url(#paint220_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M696.799 13.1035L672.587 22.8274L670.777 22.9947L694.99 13.8839L696.799 13.1035Z",
    stroke: "url(#paint221_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M557.676 -1.01159L533.463 5.87568L531.66 1.45965L555.873 -4.81445L557.676 -1.01159Z",
    stroke: "url(#paint222_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M529.857 -2.9934L505.638 -0.268227L503.835 -5.29123L528.048 -7.45898L529.857 -2.9934Z",
    stroke: "url(#paint223_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M585.5 4.46917L561.287 5.85654L559.484 2.54297L583.697 2.88981L585.5 4.46917Z",
    stroke: "url(#paint224_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M477.82 8.98362L453.601 34.6932L451.798 32.1848L476.01 5.3418L477.82 8.98362Z",
    stroke: "url(#paint225_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M503.835 -5.29138L479.622 12.4347L477.819 8.98482L502.032 -10.1348L503.835 -5.29138Z",
    stroke: "url(#paint226_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M670.777 22.9941L646.565 27.9924L644.762 27.8189L668.974 23.1304L670.777 22.9941Z",
    stroke: "url(#paint227_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M559.485 2.54339L535.272 10.2358L533.463 5.87554L557.675 -1.01172L559.485 2.54339Z",
    stroke: "url(#paint228_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M531.66 1.45905L507.448 4.8841L505.639 -0.268965L529.858 -2.99414L531.66 1.45905Z",
    stroke: "url(#paint229_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M698.602 12.2539L674.389 22.5972L672.586 22.8264L696.799 13.1024L698.602 12.2539Z",
    stroke: "url(#paint230_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M451.798 32.185L427.585 39.1962L425.782 42.5469L449.995 29.2988L451.798 32.185Z",
    stroke: "url(#paint231_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M587.31 5.7694L563.091 8.9529L561.288 5.85611L585.501 4.46875L587.31 5.7694Z",
    stroke: "url(#paint232_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M479.622 12.4342L455.41 36.8493L453.601 34.6939L477.819 8.98438L479.622 12.4342Z",
    stroke: "url(#paint233_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M505.639 -0.268018L481.426 15.6867L479.623 12.435L503.836 -5.29102L505.639 -0.268018Z",
    stroke: "url(#paint234_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M672.586 22.8281L648.367 28.1422L646.564 27.9936L670.777 22.9953L672.586 22.8281Z",
    stroke: "url(#paint235_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M561.288 5.85654L537.075 14.5214L535.272 10.2354L559.485 2.54297L561.288 5.85654Z",
    stroke: "url(#paint236_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M533.463 5.87502L509.25 10.1362L507.447 4.88404L531.66 1.45898L533.463 5.87502Z",
    stroke: "url(#paint237_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M589.112 6.82864L564.9 11.8454L563.091 8.95304L587.31 5.76953L589.112 6.82864Z",
    stroke: "url(#paint238_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M700.405 11.3203L676.193 22.2891L674.39 22.5988L698.602 12.2555L700.405 11.3203Z",
    stroke: "url(#paint239_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M453.601 34.6939L429.389 39.2524L427.586 39.1967L451.799 32.1855L453.601 34.6939Z",
    stroke: "url(#paint240_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M481.426 15.6852L457.213 38.6758L455.41 36.8487L479.623 12.4336L481.426 15.6852Z",
    stroke: "url(#paint241_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M507.448 4.88353L483.235 18.7262L481.426 15.6852L505.638 -0.269531L507.448 4.88353Z",
    stroke: "url(#paint242_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M563.091 8.95422L538.878 18.7339L537.075 14.5223L561.288 5.85742L563.091 8.95422Z",
    stroke: "url(#paint243_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M535.272 10.2353L511.053 15.4503L509.25 10.1362L533.463 5.875L535.272 10.2353Z",
    stroke: "url(#paint244_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M674.389 22.5977L650.176 28.2586L648.367 28.1409L672.586 22.8268L674.389 22.5977Z",
    stroke: "url(#paint245_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M590.915 7.65806L566.702 14.5577L564.899 11.8449L589.112 6.82812L590.915 7.65806Z",
    stroke: "url(#paint246_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M455.41 36.8487L431.192 40.2614L429.389 39.2518L453.601 34.6934L455.41 36.8487Z",
    stroke: "url(#paint247_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M702.214 10.2793L678.002 21.8861L676.192 22.2887L700.405 11.3198L702.214 10.2793Z",
    stroke: "url(#paint248_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M509.25 10.1369L485.037 21.5393L483.234 18.7274L507.447 4.88477L509.25 10.1369Z",
    stroke: "url(#paint249_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M483.235 18.7266L459.016 40.1936L457.213 38.6761L481.425 15.6855L483.235 18.7266Z",
    stroke: "url(#paint250_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M429.389 39.253L405.176 54.3282L403.373 55.1148L427.586 39.1973L429.389 39.253Z",
    stroke: "url(#paint251_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M537.075 14.5223L512.863 20.7964L511.054 15.4513L535.273 10.2363L537.075 14.5223Z",
    stroke: "url(#paint252_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M564.9 11.8455L540.687 22.8515L538.878 18.7328L563.09 8.95312L564.9 11.8455Z",
    stroke: "url(#paint253_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M676.192 22.2891L651.98 28.3216L650.177 28.2597L674.389 22.5987L676.192 22.2891Z",
    stroke: "url(#paint254_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M592.725 8.29614L568.506 17.1158L566.703 14.5579L590.916 7.6582L592.725 8.29614Z",
    stroke: "url(#paint255_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M457.213 38.6767L433.001 41.0365L431.191 40.2623L455.41 36.8496L457.213 38.6767Z",
    stroke: "url(#paint256_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M511.054 15.4508L486.841 24.1156L485.038 21.5391L509.251 10.1367L511.054 15.4508Z",
    stroke: "url(#paint257_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M538.878 18.7331L514.665 26.153L512.862 20.7956L537.075 14.5215L538.878 18.7331Z",
    stroke: "url(#paint258_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M704.017 9.12695L679.804 21.3655L678.001 21.8857L702.214 10.279L704.017 9.12695Z",
    stroke: "url(#paint259_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M485.037 21.5385L460.825 41.4075L459.016 40.1935L483.234 18.7266L485.037 21.5385Z",
    stroke: "url(#paint260_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M566.703 14.5585L542.49 26.8775L540.688 22.8517L564.9 11.8457L566.703 14.5585Z",
    stroke: "url(#paint261_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M431.191 40.2615L406.979 53.4043L405.176 54.3272L429.388 39.252L431.191 40.2615Z",
    stroke: "url(#paint262_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M594.528 8.76758L570.315 19.5382L568.506 17.1165L592.725 8.29688L594.528 8.76758Z",
    stroke: "url(#paint263_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M678.001 21.8848L653.782 28.3137L651.979 28.3199L676.192 22.2873L678.001 21.8848Z",
    stroke: "url(#paint264_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M459.016 40.1932L434.803 44.9189L433 41.0355L457.213 38.6758L459.016 40.1932Z",
    stroke: "url(#paint265_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M540.687 22.8512L516.468 31.4912L514.665 26.1523L538.878 18.7324L540.687 22.8512Z",
    stroke: "url(#paint266_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M512.863 20.7962L488.65 26.451L486.841 24.116L511.053 15.4512L512.863 20.7962Z",
    stroke: "url(#paint267_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M568.506 17.1165L544.293 30.8106L542.49 26.8776L566.703 14.5586L568.506 17.1165Z",
    stroke: "url(#paint268_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M486.841 24.1156L462.628 42.3495L460.825 41.4081L485.038 21.5391L486.841 24.1156Z",
    stroke: "url(#paint269_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M433 41.0359L408.788 56.6438L406.979 53.4045L431.191 40.2617L433 41.0359Z",
    stroke: "url(#paint270_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M596.33 9.10204L572.117 21.8608L570.314 19.5382L594.527 8.76758L596.33 9.10204Z",
    stroke: "url(#paint271_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M542.49 26.8774L518.278 36.7995L516.469 31.4916L540.688 22.8516L542.49 26.8774Z",
    stroke: "url(#paint272_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M460.825 41.4073L436.613 49.3661L434.804 44.9191L459.016 40.1934L460.825 41.4073Z",
    stroke: "url(#paint273_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M679.804 21.3652L655.591 28.1348L653.782 28.3144L678.001 21.8855L679.804 21.3652Z",
    stroke: "url(#paint274_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M514.665 26.1524L490.452 28.5369L488.649 26.4497L512.862 20.7949L514.665 26.1524Z",
    stroke: "url(#paint275_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M570.315 19.5389L546.096 34.6574L544.293 30.8112L568.506 17.1172L570.315 19.5389Z",
    stroke: "url(#paint276_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M434.804 44.9205L410.591 60.7513L408.788 56.6449L433.001 41.0371L434.804 44.9205Z",
    stroke: "url(#paint277_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M488.65 26.4502L464.431 43.0304L462.628 42.3492L486.841 24.1152L488.65 26.4502Z",
    stroke: "url(#paint278_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M544.293 30.8099L520.08 42.0265L518.277 36.7991L542.49 26.877L544.293 30.8099Z",
    stroke: "url(#paint279_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M598.133 9.34311L573.92 24.1024L572.117 21.8603L596.33 9.10156L598.133 9.34311Z",
    stroke: "url(#paint280_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M462.628 42.3496L438.415 53.7458L436.612 49.367L460.825 41.4082L462.628 42.3496Z",
    stroke: "url(#paint281_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M572.117 21.8617L547.905 38.3304L546.096 34.6576L570.314 19.5391L572.117 21.8617Z",
    stroke: "url(#paint282_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M516.469 31.4912L492.256 30.3887L490.453 28.5369L514.666 26.1523L516.469 31.4912Z",
    stroke: "url(#paint283_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M436.613 49.3669L412.394 64.6155L410.591 60.7507L434.803 44.9199L436.613 49.3669Z",
    stroke: "url(#paint284_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M490.452 28.5384L466.24 43.5331L464.431 43.0314L488.649 26.4512L490.452 28.5384Z",
    stroke: "url(#paint285_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M546.096 34.6568L521.883 46.9696L520.08 42.0271L544.293 30.8105L546.096 34.6568Z",
    stroke: "url(#paint286_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M408.787 56.6444L384.569 52.123L382.766 54.2598L406.978 53.4051L408.787 56.6444Z",
    stroke: "url(#paint287_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M464.431 43.0309L440.218 58.0813L438.415 53.7458L462.628 42.3496L464.431 43.0309Z",
    stroke: "url(#paint288_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M599.943 9.51717L575.724 26.1284L573.921 24.1031L598.134 9.34375L599.943 9.51717Z",
    stroke: "url(#paint289_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M573.921 24.1034L549.708 41.6994L547.905 38.3301L572.118 21.8613L573.921 24.1034Z",
    stroke: "url(#paint290_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M518.278 36.799L494.059 34.8047L492.256 30.3887L516.469 31.4911L518.278 36.799Z",
    stroke: "url(#paint291_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M438.415 53.7461L414.203 68.2205L412.394 64.6158L436.612 49.3672L438.415 53.7461Z",
    stroke: "url(#paint292_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M547.905 38.3291L523.686 51.5957L521.883 46.9691L546.095 34.6562L547.905 38.3291Z",
    stroke: "url(#paint293_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M492.256 30.389L468.043 43.9777L466.24 43.5318L490.453 28.5371L492.256 30.389Z",
    stroke: "url(#paint294_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M466.241 43.5329L442.022 62.3552L440.219 58.0817L464.431 43.0312L466.241 43.5329Z",
    stroke: "url(#paint295_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M410.591 60.7507L386.378 53.0025L384.569 52.123L408.788 56.6444L410.591 60.7507Z",
    stroke: "url(#paint296_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M601.745 9.5919L577.533 27.9373L575.724 26.1288L599.942 9.51758L601.745 9.5919Z",
    stroke: "url(#paint297_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M520.08 42.0264L495.868 39.5985L494.059 34.8047L518.277 36.799L520.08 42.0264Z",
    stroke: "url(#paint298_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M575.724 26.1288L551.511 44.7839L549.708 41.6995L573.921 24.1035L575.724 26.1288Z",
    stroke: "url(#paint299_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M440.219 58.0816L416.006 71.5712L414.203 68.2205L438.416 53.7461L440.219 58.0816Z",
    stroke: "url(#paint300_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M549.708 41.6994L525.496 55.9075L523.687 51.5967L547.905 38.3301L549.708 41.6994Z",
    stroke: "url(#paint301_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M468.043 43.9791L443.831 66.561L442.021 62.3555L466.24 43.5332L468.043 43.9791Z",
    stroke: "url(#paint302_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M494.059 34.8047L469.846 44.4047L468.043 43.9774L492.256 30.3887L494.059 34.8047Z",
    stroke: "url(#paint303_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M412.393 64.6149L388.181 55.7457L386.378 53.002L410.591 60.7501L412.393 64.6149Z",
    stroke: "url(#paint304_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M629.57 23.8115L605.357 11.7959L603.548 9.46094L627.767 23.254L629.57 23.8115Z",
    stroke: "url(#paint305_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M521.883 46.97L497.67 44.1581L495.867 39.5996L520.08 42.0275L521.883 46.97Z",
    stroke: "url(#paint306_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M603.548 9.46094L579.335 29.5591L577.532 27.9364L601.745 9.591L603.548 9.46094Z",
    stroke: "url(#paint307_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M577.532 27.9374L553.32 47.6144L551.511 44.784L575.723 26.1289L577.532 27.9374Z",
    stroke: "url(#paint308_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M442.021 62.3536L417.809 74.6789L416.006 71.5697L440.218 58.0801L442.021 62.3536Z",
    stroke: "url(#paint309_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M551.511 44.7836L527.298 59.9208L525.495 55.9073L549.708 41.6992L551.511 44.7836Z",
    stroke: "url(#paint310_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M469.846 44.4059L445.633 70.6729L443.83 66.5603L468.043 43.9785L469.846 44.4059Z",
    stroke: "url(#paint311_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M523.686 51.5967L499.474 48.4999L497.671 44.1582L521.884 46.9701L523.686 51.5967Z",
    stroke: "url(#paint312_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M631.373 24.1221L607.16 14.999L605.357 11.7969L629.57 23.8124L631.373 24.1221Z",
    stroke: "url(#paint313_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M495.867 39.5985L471.649 44.8507L469.846 44.4047L494.058 34.8047L495.867 39.5985Z",
    stroke: "url(#paint314_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M414.202 68.22L389.984 58.1306L388.181 55.7461L412.393 64.6153L414.202 68.22Z",
    stroke: "url(#paint315_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M605.358 11.7959L581.139 31.0518L579.336 29.5591L603.549 9.46094L605.358 11.7959Z",
    stroke: "url(#paint316_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M579.336 29.5602L555.123 50.2282L553.32 47.6145L577.533 27.9375L579.336 29.5602Z",
    stroke: "url(#paint317_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M443.83 66.5609L419.618 77.5483L417.809 74.6807L442.021 62.3555L443.83 66.5609Z",
    stroke: "url(#paint318_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M553.32 47.6137L529.101 63.6489L527.298 59.9203L551.51 44.7832L553.32 47.6137Z",
    stroke: "url(#paint319_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M471.649 44.8522L447.437 74.6929L445.634 70.6733L469.846 44.4062L471.649 44.8522Z",
    stroke: "url(#paint320_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M525.495 55.9075L501.283 52.6187L499.474 48.5L523.686 51.5968L525.495 55.9075Z",
    stroke: "url(#paint321_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M633.182 24.1645L608.963 17.971L607.16 14.998L631.373 24.1212L633.182 24.1645Z",
    stroke: "url(#paint322_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M416.006 71.5709L391.793 60.1995L389.984 58.1309L414.203 68.2202L416.006 71.5709Z",
    stroke: "url(#paint323_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M497.67 44.1581L473.458 45.7127L471.648 44.8518L495.867 39.5996L497.67 44.1581Z",
    stroke: "url(#paint324_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M581.139 31.0532L556.926 52.644L555.123 50.2285L579.336 29.5605L581.139 31.0532Z",
    stroke: "url(#paint325_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M607.16 14.999L582.948 32.4463L581.139 31.0527L605.357 11.7969L607.16 14.999Z",
    stroke: "url(#paint326_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M555.123 50.227L530.911 67.1107L529.102 63.6485L553.32 47.6133L555.123 50.227Z",
    stroke: "url(#paint327_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M473.458 45.7125L449.246 78.6004L447.437 74.6923L471.649 44.8516L473.458 45.7125Z",
    stroke: "url(#paint328_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M527.299 59.9214L503.086 56.5211L501.283 52.6191L525.496 55.9079L527.299 59.9214Z",
    stroke: "url(#paint329_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M634.985 23.9227L610.772 20.6959L608.963 17.9707L633.182 24.1643L634.985 23.9227Z",
    stroke: "url(#paint330_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M499.474 48.4999L475.261 49.5281L473.458 45.7128L497.671 44.1582L499.474 48.4999Z",
    stroke: "url(#paint331_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M417.809 74.6798L393.596 61.9706L391.793 60.1992L416.006 71.5706L417.809 74.6798Z",
    stroke: "url(#paint332_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M608.963 17.971L584.75 36.496L582.947 32.4454L607.16 14.998L608.963 17.971Z",
    stroke: "url(#paint333_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M582.947 32.4463L558.735 54.8981L556.926 52.6436L581.138 31.0527L582.947 32.4463Z",
    stroke: "url(#paint334_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M388.182 55.7464L363.969 31.7338L362.166 29.5723L386.379 53.0026L388.182 55.7464Z",
    stroke: "url(#paint335_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M556.926 52.644L532.713 70.3453L530.91 67.1122L555.123 50.2285L556.926 52.644Z",
    stroke: "url(#paint336_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M475.261 49.5281L451.048 82.3913L449.245 78.6008L473.458 45.7129L475.261 49.5281Z",
    stroke: "url(#paint337_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M529.102 63.6483L504.889 60.2295L503.086 56.5195L527.299 59.9198L529.102 63.6483Z",
    stroke: "url(#paint338_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M501.283 52.6187L477.064 53.3867L475.261 49.5281L499.473 48.5L501.283 52.6187Z",
    stroke: "url(#paint339_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M636.788 23.3977L612.575 23.1499L610.772 20.6973L634.985 23.9241L636.788 23.3977Z",
    stroke: "url(#paint340_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M610.773 20.6959L586.554 40.5959L584.751 36.4957L608.964 17.9707L610.773 20.6959Z",
    stroke: "url(#paint341_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M419.617 77.5476L395.399 63.4819L393.596 61.9707L417.808 74.6799L419.617 77.5476Z",
    stroke: "url(#paint342_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M584.751 36.4959L560.538 57.04L558.735 54.8971L582.948 32.4453L584.751 36.4959Z",
    stroke: "url(#paint343_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M389.984 58.1314L365.772 33.6172L363.969 31.7344L388.181 55.7469L389.984 58.1314Z",
    stroke: "url(#paint344_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M558.735 54.897L534.516 73.3601L532.713 70.3439L556.925 52.6426L558.735 54.897Z",
    stroke: "url(#paint345_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M477.063 53.3859L452.851 86.0509L451.048 82.3905L475.26 49.5273L477.063 53.3859Z",
    stroke: "url(#paint346_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M530.91 67.1115L506.698 63.7608L504.889 60.2305L529.101 63.6493L530.91 67.1115Z",
    stroke: "url(#paint347_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M503.085 56.5211L478.873 57.2705L477.063 53.3872L501.282 52.6191L503.085 56.5211Z",
    stroke: "url(#paint348_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M638.597 22.5664L614.378 25.3102L612.575 23.1486L636.788 23.3964L638.597 22.5664Z",
    stroke: "url(#paint349_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M612.575 23.1499L588.363 44.3877L586.554 40.5972L610.772 20.6973L612.575 23.1499Z",
    stroke: "url(#paint350_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M421.421 80.2051L397.209 64.7769L395.399 63.4824L419.618 77.5481L421.421 80.2051Z",
    stroke: "url(#paint351_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M586.554 40.5962L562.341 59.0903L560.538 57.0402L584.751 36.4961L586.554 40.5962Z",
    stroke: "url(#paint352_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M560.538 57.0414L536.326 76.2044L534.517 73.3615L558.735 54.8984L560.538 57.0414Z",
    stroke: "url(#paint353_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M478.873 57.2701L454.661 89.5635L452.852 86.0517L477.064 53.3867L478.873 57.2701Z",
    stroke: "url(#paint354_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M532.713 70.3436L508.5 67.1353L506.697 63.7598L530.91 67.1105L532.713 70.3436Z",
    stroke: "url(#paint355_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M363.968 31.7336L339.755 25.6949L337.946 22.9883L362.165 29.5721L363.968 31.7336Z",
    stroke: "url(#paint356_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M504.889 60.2295L480.676 61.1338L478.873 57.269L503.086 56.5195L504.889 60.2295Z",
    stroke: "url(#paint357_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M614.378 25.31L590.165 47.8237L588.362 44.3862L612.575 23.1484L614.378 25.31Z",
    stroke: "url(#paint358_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M640.4 21.4336L616.187 27.175L614.378 25.3108L638.597 22.567L640.4 21.4336Z",
    stroke: "url(#paint359_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M588.363 44.3862L564.15 61.1027L562.341 59.0897L586.553 40.5957L588.363 44.3862Z",
    stroke: "url(#paint360_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M480.676 61.1343L456.463 92.9198L454.66 89.5629L478.873 57.2695L480.676 61.1343Z",
    stroke: "url(#paint361_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M562.341 59.0911L538.128 78.8982L536.325 76.204L560.538 57.041L562.341 59.0911Z",
    stroke: "url(#paint362_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M365.771 33.6169L341.559 29.1328L339.756 25.6953L363.968 31.7341L365.771 33.6169Z",
    stroke: "url(#paint363_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M339.756 25.6949L315.537 46.462L313.734 44.2818L337.947 22.9883L339.756 25.6949Z",
    stroke: "url(#paint364_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M506.698 63.7608L482.479 64.9624L480.676 61.1347L504.888 60.2305L506.698 63.7608Z",
    stroke: "url(#paint365_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M616.188 27.1748L591.969 50.9024L590.166 47.8242L614.379 25.3105L616.188 27.1748Z",
    stroke: "url(#paint366_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M642.203 19.9961L617.99 28.7228L616.188 27.1745L640.4 21.433L642.203 19.9961Z",
    stroke: "url(#paint367_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M590.166 47.8242L565.953 63.1038L564.15 61.1032L588.363 44.3867L590.166 47.8242Z",
    stroke: "url(#paint368_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M482.479 64.9624L458.266 96.1099L456.463 92.9202L480.676 61.1348L482.479 64.9624Z",
    stroke: "url(#paint369_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M564.15 61.1028L539.931 81.492L538.128 78.8969L562.341 59.0898L564.15 61.1028Z",
    stroke: "url(#paint370_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M367.58 35.2583L343.362 32.6012L341.559 29.1328L365.771 33.617L367.58 35.2583Z",
    stroke: "url(#paint371_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M508.5 67.1353L484.288 68.7146L482.479 64.9613L506.697 63.7598L508.5 67.1353Z",
    stroke: "url(#paint372_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M341.559 29.1328L317.346 49.9928L315.537 46.4624L339.756 25.6953L341.559 29.1328Z",
    stroke: "url(#paint373_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M617.99 28.7242L593.778 53.579L591.969 50.9034L616.188 27.1758L617.99 28.7242Z",
    stroke: "url(#paint374_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M644.012 18.2695L619.793 29.9506L617.99 28.7243L642.203 19.9975L644.012 18.2695Z",
    stroke: "url(#paint375_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M591.969 50.9024L567.756 65.1477L565.953 63.1038L590.166 47.8242L591.969 50.9024Z",
    stroke: "url(#paint376_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M565.953 63.104L541.741 84.0198L539.932 81.4928L564.15 61.1035L565.953 63.104Z",
    stroke: "url(#paint377_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M369.383 36.7017L345.17 36.0823L343.361 32.6016L367.58 35.2586L369.383 36.7017Z",
    stroke: "url(#paint378_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M343.362 32.6012L319.15 53.486L317.347 49.9928L341.559 29.1328L343.362 32.6012Z",
    stroke: "url(#paint379_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M315.537 46.4614L291.324 48.4991L289.521 46.6782L313.734 44.2812L315.537 46.4614Z",
    stroke: "url(#paint380_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M619.793 29.949L595.58 55.8382L593.777 53.5775L617.99 28.7227L619.793 29.949Z",
    stroke: "url(#paint381_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M645.815 16.25L621.602 30.8545L619.793 29.9502L644.012 18.2691L645.815 16.25Z",
    stroke: "url(#paint382_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M593.778 53.578L569.559 67.2658L567.756 65.1476L591.968 50.9023L593.778 53.578Z",
    stroke: "url(#paint383_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M567.756 65.1474L543.543 86.5214L541.74 84.0192L565.953 63.1035L567.756 65.1474Z",
    stroke: "url(#paint384_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M371.186 37.9897L346.974 39.5814L345.171 36.082L369.384 36.7014L371.186 37.9897Z",
    stroke: "url(#paint385_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M345.171 36.0824L320.952 56.93L319.149 53.4863L343.362 32.6016L345.171 36.0824Z",
    stroke: "url(#paint386_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M317.346 49.9913L293.133 51.2981L291.324 48.4986L315.537 46.4609L317.346 49.9913Z",
    stroke: "url(#paint387_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M621.603 30.8535L597.384 57.6593L595.581 55.8384L619.794 29.9492L621.603 30.8535Z",
    stroke: "url(#paint388_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M647.618 13.9766L623.405 31.4363L621.603 30.8541L645.815 16.2496L647.618 13.9766Z",
    stroke: "url(#paint389_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M595.58 55.8388L571.368 69.5018L569.559 67.2659L593.777 53.5781L595.58 55.8388Z",
    stroke: "url(#paint390_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M372.989 39.1651L348.777 43.0856L346.974 39.58L371.186 37.9883L372.989 39.1651Z",
    stroke: "url(#paint391_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M346.974 39.5814L322.761 60.2928L320.952 56.9296L345.171 36.082L346.974 39.5814Z",
    stroke: "url(#paint392_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M319.149 53.4854L294.937 54.0242L293.134 51.299L317.346 49.9922L319.149 53.4854Z",
    stroke: "url(#paint393_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M623.406 31.4357L599.187 59.0281L597.384 57.6593L621.603 30.8535L623.406 31.4357Z",
    stroke: "url(#paint394_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M597.384 57.6608L573.171 71.906L571.368 69.5029L595.581 55.8398L597.384 57.6608Z",
    stroke: "url(#paint395_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M374.798 40.2685L350.579 46.5921L348.776 43.0866L372.989 39.166L374.798 40.2685Z",
    stroke: "url(#paint396_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M649.421 11.4609L625.208 31.7078L623.405 31.4352L647.618 13.9755L649.421 11.4609Z",
    stroke: "url(#paint397_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M348.776 43.0857L324.564 63.5616L322.761 60.2914L346.973 39.5801L348.776 43.0857Z",
    stroke: "url(#paint398_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M320.952 56.93L296.739 56.6636L294.937 54.0252L319.149 53.4863L320.952 56.93Z",
    stroke: "url(#paint399_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M291.324 48.5L267.112 27.1136L265.309 25.0449L289.521 46.6791L291.324 48.5Z",
    stroke: "url(#paint400_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M625.208 31.7081L600.996 59.9322L599.187 59.028L623.405 31.4355L625.208 31.7081Z",
    stroke: "url(#paint401_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M376.602 41.3638L352.389 50.1092L350.58 46.5912L374.799 40.2676L376.602 41.3638Z",
    stroke: "url(#paint402_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M599.186 59.0289L574.974 74.5067L573.171 71.9054L597.384 57.6602L599.186 59.0289Z",
    stroke: "url(#paint403_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M350.58 46.5915L326.367 66.7021L324.564 63.5619L348.777 43.0859L350.58 46.5915Z",
    stroke: "url(#paint404_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M651.23 8.75586L627.017 31.6721L625.208 31.7093L649.421 11.4625L651.23 8.75586Z",
    stroke: "url(#paint405_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M322.761 60.2916L298.542 59.1767L296.739 56.6621L320.952 56.9284L322.761 60.2916Z",
    stroke: "url(#paint406_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M293.134 51.2992L268.915 29.151L267.112 27.1133L291.325 48.4997L293.134 51.2992Z",
    stroke: "url(#paint407_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M627.018 31.6719L602.799 60.3544L600.996 59.9332L625.209 31.709L627.018 31.6719Z",
    stroke: "url(#paint408_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M378.404 42.4987L354.192 53.6409L352.389 50.1106L376.601 41.3652L378.404 42.4987Z",
    stroke: "url(#paint409_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M600.995 59.9336L576.783 77.3313L574.974 74.5071L599.186 59.0293L600.995 59.9336Z",
    stroke: "url(#paint410_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M352.389 50.1098L328.176 69.6939L326.367 66.7024L350.58 46.5918L352.389 50.1098Z",
    stroke: "url(#paint411_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M653.033 5.90625L628.82 31.4672L627.018 31.6716L651.23 8.7553L653.033 5.90625Z",
    stroke: "url(#paint412_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M107.394 64.6035L83.175 105.698L81.3721 102.217L105.585 70.0043L107.394 64.6035Z",
    stroke: "url(#paint413_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M324.564 63.5628L300.351 61.5437L298.542 59.1777L322.761 60.2926L324.564 63.5628Z",
    stroke: "url(#paint414_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M294.937 54.0238L270.724 31.1385L268.915 29.1504L293.134 51.2987L294.937 54.0238Z",
    stroke: "url(#paint415_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M380.213 43.7244L355.994 57.1892L354.191 53.6403L378.404 42.498L380.213 43.7244Z",
    stroke: "url(#paint416_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M628.821 31.4668L604.602 60.4714L602.799 60.3537L627.018 31.6712L628.821 31.4668Z",
    stroke: "url(#paint417_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M602.799 60.3548L578.586 79.9946L576.783 77.3314L600.996 59.9336L602.799 60.3548Z",
    stroke: "url(#paint418_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M354.191 53.6397L329.979 72.5178L328.176 69.6935L352.388 50.1094L354.191 53.6397Z",
    stroke: "url(#paint419_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M133.41 47.248L109.197 67.5568L107.395 64.6025L131.607 48.301L133.41 47.248Z",
    stroke: "url(#paint420_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M109.198 67.5579L84.9849 108.943L83.1758 105.698L107.395 64.6035L109.198 67.5579Z",
    stroke: "url(#paint421_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M654.836 4.45703L630.623 33.7775L628.82 31.4673L653.033 5.90633L654.836 4.45703Z",
    stroke: "url(#paint422_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M326.367 66.7022L302.154 63.7293L300.352 61.543L324.564 63.5621L326.367 66.7022Z",
    stroke: "url(#paint423_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M267.112 27.1137L242.9 10.583L241.097 8.97266L265.309 25.045L267.112 27.1137Z",
    stroke: "url(#paint424_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M296.739 56.6624L272.527 33.0773L270.724 31.1387L294.936 54.024L296.739 56.6624Z",
    stroke: "url(#paint425_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M382.017 45.1058L357.804 60.7632L355.995 57.1895L380.214 43.7246L382.017 45.1058Z",
    stroke: "url(#paint426_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M604.602 60.4712L580.389 82.3469L578.586 79.9934L602.799 60.3535L604.602 60.4712Z",
    stroke: "url(#paint427_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M630.623 33.777L606.411 60.7315L604.602 60.4714L628.82 31.4668L630.623 33.777Z",
    stroke: "url(#paint428_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M355.995 57.1895L331.782 75.058L329.979 72.5187L354.192 53.6406L355.995 57.1895Z",
    stroke: "url(#paint429_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M135.213 46.1094L111 71.9056L109.197 67.5578L133.41 47.249L135.213 46.1094Z",
    stroke: "url(#paint430_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M161.235 26.3008L137.022 51.2919L135.213 46.1079L159.432 28.227L161.235 26.3008Z",
    stroke: "url(#paint431_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M656.645 4.32031L632.432 35.8209L630.623 33.777L654.836 4.45657L656.645 4.32031Z",
    stroke: "url(#paint432_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M328.176 69.6949L303.957 65.6009L302.154 63.7305L326.367 66.7034L328.176 69.6949Z",
    stroke: "url(#paint433_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M268.915 29.1504L244.702 12.2419L242.899 10.582L267.112 27.1127L268.915 29.1504Z",
    stroke: "url(#paint434_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M298.543 59.1779L274.33 34.9362L272.527 33.0781L296.74 56.6633L298.543 59.1779Z",
    stroke: "url(#paint435_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M383.819 46.691L359.607 64.2808L357.804 60.7629L382.016 45.1055L383.819 46.691Z",
    stroke: "url(#paint436_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M682.66 -6.32617L658.447 5.869L656.645 4.3206L680.857 -4.24513L682.66 -6.32617Z",
    stroke: "url(#paint437_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M606.41 60.7328L582.198 84.4109L580.389 82.3484L604.601 60.4727L606.41 60.7328Z",
    stroke: "url(#paint438_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M137.022 51.2934L112.803 76.1235L111 71.9056L135.213 46.1094L137.022 51.2934Z",
    stroke: "url(#paint439_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M163.037 27.5581L138.824 56.383L137.021 51.2919L161.234 26.3008L163.037 27.5581Z",
    stroke: "url(#paint440_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M357.804 60.7632L333.591 77.2443L331.782 75.0579L355.995 57.1895L357.804 60.7632Z",
    stroke: "url(#paint441_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M632.432 35.8212L608.213 61.1468L606.41 60.7318L630.623 33.7773L632.432 35.8212Z",
    stroke: "url(#paint442_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M189.059 -1.33984L164.84 31.9073L163.037 27.5594L187.25 1.63307L189.059 -1.33984Z",
    stroke: "url(#paint443_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M658.448 5.86871L634.236 37.4931L632.433 35.8209L656.645 4.32031L658.448 5.86871Z",
    stroke: "url(#paint444_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M270.724 31.1388L246.511 13.9392L244.702 12.2422L268.915 29.1507L270.724 31.1388Z",
    stroke: "url(#paint445_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M411.644 73.137L387.432 52.1594L385.629 48.5547L409.841 71.7559L411.644 73.137Z",
    stroke: "url(#paint446_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 61.5432L276.139 36.5954L274.33 34.9355L298.543 59.1772L300.352 61.5432Z",
    stroke: "url(#paint447_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M385.628 48.5557L361.409 67.6753L359.606 64.2812L383.819 46.6914L385.628 48.5557Z",
    stroke: "url(#paint448_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M215.075 -5.86719L190.863 2.14111L189.06 -1.33968L213.272 -2.75181L215.075 -5.86719Z",
    stroke: "url(#paint449_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M684.47 -6.76562L660.251 7.27523L658.448 5.86928L682.661 -6.32588L684.47 -6.76562Z",
    stroke: "url(#paint450_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M164.841 31.9065L140.628 61.3012L138.825 56.3835L163.038 27.5586L164.841 31.9065Z",
    stroke: "url(#paint451_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M138.824 56.3841L114.612 80.1241L112.803 76.123L137.022 51.293L138.824 56.3841Z",
    stroke: "url(#paint452_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M608.214 61.1474L584.001 86.2624L582.198 84.4105L606.411 60.7324L608.214 61.1474Z",
    stroke: "url(#paint453_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M359.606 64.2816L335.394 79.1215L333.591 77.2448L357.803 60.7637L359.606 64.2816Z",
    stroke: "url(#paint454_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M242.9 10.5815L218.687 -2.87096L216.878 -4.35742L241.097 8.97117L242.9 10.5815Z",
    stroke: "url(#paint455_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M190.862 2.14095L166.649 36.0013L164.84 31.9073L189.059 -1.33984L190.862 2.14095Z",
    stroke: "url(#paint456_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M634.236 37.4945L610.017 61.7424L608.214 61.1478L632.433 35.8223L634.236 37.4945Z",
    stroke: "url(#paint457_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M413.447 74.8101L389.235 56.4709L387.432 52.1602L411.644 73.1378L413.447 74.8101Z",
    stroke: "url(#paint458_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M660.251 7.27509L636.038 38.819L634.235 37.4936L658.448 5.86914L660.251 7.27509Z",
    stroke: "url(#paint459_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M272.527 33.0776L248.315 15.7851L246.512 13.9395L270.724 31.139L272.527 33.0776Z",
    stroke: "url(#paint460_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M387.432 52.1594L363.219 70.9445L361.41 67.6743L385.629 48.5547L387.432 52.1594Z",
    stroke: "url(#paint461_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M216.878 -4.35595L192.665 5.87585L190.862 2.14112L215.075 -5.86719L216.878 -4.35595Z",
    stroke: "url(#paint462_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M166.65 36.0002L142.437 65.9586L140.628 61.301L164.841 31.9062L166.65 36.0002Z",
    stroke: "url(#paint463_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M140.628 61.3025L116.415 83.8471L114.612 80.1248L138.825 56.3848L140.628 61.3025Z",
    stroke: "url(#paint464_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M686.273 -7.27344L662.06 8.4211L660.251 7.2753L684.47 -6.76556L686.273 -7.27344Z",
    stroke: "url(#paint465_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M610.017 61.7411L585.804 87.9337L584.001 86.2615L608.214 61.1465L610.017 61.7411Z",
    stroke: "url(#paint466_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M192.665 5.87536L168.452 39.8162L166.649 36.0009L190.862 2.14062L192.665 5.87536Z",
    stroke: "url(#paint467_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M361.41 67.6753L337.197 80.719L335.395 79.1211L359.607 64.2812L361.41 67.6753Z",
    stroke: "url(#paint468_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M244.702 12.2432L220.489 -1.27739L218.687 -2.86914L242.899 10.5833L244.702 12.2432Z",
    stroke: "url(#paint469_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M636.038 38.8196L611.826 63.4019L610.017 61.742L634.235 37.4941L636.038 38.8196Z",
    stroke: "url(#paint470_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M415.256 76.86L391.043 60.8496L389.234 56.4707L413.447 74.8099L415.256 76.86Z",
    stroke: "url(#paint471_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M662.06 8.4212L637.841 39.8846L636.038 38.8193L660.251 7.27539L662.06 8.4212Z",
    stroke: "url(#paint472_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M274.33 34.9357L250.117 17.9777L248.314 15.7852L272.527 33.0776L274.33 34.9357Z",
    stroke: "url(#paint473_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M389.234 56.4709L365.022 74.0793L363.219 70.9453L387.431 52.1602L389.234 56.4709Z",
    stroke: "url(#paint474_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M218.687 -2.87096L194.474 9.27466L192.665 5.87438L216.878 -4.35742L218.687 -2.87096Z",
    stroke: "url(#paint475_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M168.452 39.8153L144.239 70.2877L142.437 65.9584L166.649 36L168.452 39.8153Z",
    stroke: "url(#paint476_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M142.437 65.9584L118.218 87.2333L116.415 83.8454L140.628 61.3008L142.437 65.9584Z",
    stroke: "url(#paint477_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M688.075 -7.83203L663.863 9.34898L662.06 8.41994L686.272 -7.27461L688.075 -7.83203Z",
    stroke: "url(#paint478_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M194.474 9.27528L170.255 43.2966L168.452 39.8158L192.665 5.875L194.474 9.27528Z",
    stroke: "url(#paint479_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M611.826 63.4021L587.607 89.4399L585.804 87.9349L610.016 61.7422L611.826 63.4021Z",
    stroke: "url(#paint480_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M417.06 79.2507L392.847 65.247L391.044 60.8496L415.257 76.86L417.06 79.2507Z",
    stroke: "url(#paint481_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M246.511 13.9403L222.292 0.611701L220.489 -1.27734L244.702 12.2432L246.511 13.9403Z",
    stroke: "url(#paint482_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M637.841 39.8837L613.628 64.8748L611.825 63.4007L636.038 38.8184L637.841 39.8837Z",
    stroke: "url(#paint483_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M276.139 36.5964L251.92 20.4931L250.117 17.9785L274.33 34.9365L276.139 36.5964Z",
    stroke: "url(#paint484_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M663.863 9.34896L639.65 40.7381L637.841 39.8833L662.06 8.41992L663.863 9.34896Z",
    stroke: "url(#paint485_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M391.043 60.8496L366.824 77.0829L365.021 74.0791L389.234 56.4707L391.043 60.8496Z",
    stroke: "url(#paint486_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M220.489 -1.27739L196.277 12.3671L194.474 9.27648L218.686 -2.86914L220.489 -1.27739Z",
    stroke: "url(#paint487_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M170.256 43.2972L146.043 74.2465L144.24 70.2888L168.453 39.8164L170.256 43.2972Z",
    stroke: "url(#paint488_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M196.277 12.366L172.064 46.4245L170.255 43.2968L194.474 9.27539L196.277 12.366Z",
    stroke: "url(#paint489_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M689.879 -6.81009L665.666 10.1479L663.863 9.34897L688.076 -7.83203L689.879 -6.81009Z",
    stroke: "url(#paint490_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M613.628 64.8745L589.416 90.8132L587.606 89.4382L611.825 63.4004L613.628 64.8745Z",
    stroke: "url(#paint491_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M248.315 15.7856L224.102 2.77908L222.293 0.611328L246.512 13.9399L248.315 15.7856Z",
    stroke: "url(#paint492_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M639.651 40.7395L615.432 66.1951L613.629 64.8759L637.841 39.8848L639.651 40.7395Z",
    stroke: "url(#paint493_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M277.942 37.8776L253.729 23.2855L251.92 20.4922L276.139 36.5955L277.942 37.8776Z",
    stroke: "url(#paint494_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M392.846 65.2471L368.633 79.9568L366.824 77.083L391.043 60.8496L392.846 65.2471Z",
    stroke: "url(#paint495_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M172.065 46.4246L147.846 77.789L146.043 74.2462L170.256 43.2969L172.065 46.4246Z",
    stroke: "url(#paint496_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M222.293 0.611701L198.08 15.1356L196.277 12.3671L220.49 -1.27734L222.293 0.611701Z",
    stroke: "url(#paint497_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M665.666 10.1486L641.453 41.4138L639.65 40.7387L663.863 9.34961L665.666 10.1486Z",
    stroke: "url(#paint498_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M745.528 -8.09835L721.315 0.0338209L719.512 -1.28541L743.725 -9.46094L745.528 -8.09835Z",
    stroke: "url(#paint499_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M198.08 15.1338L173.867 49.1861L172.064 46.4237L196.277 12.3652L198.08 15.1338Z",
    stroke: "url(#paint500_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M691.688 -4.75852L667.475 10.8184L665.666 10.1494L689.879 -6.80859L691.688 -4.75852Z",
    stroke: "url(#paint501_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M250.117 17.9784L225.905 5.18241L224.102 2.7793L248.314 15.7858L250.117 17.9784Z",
    stroke: "url(#paint502_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M641.453 41.4134L617.241 67.3645L615.432 66.1939L639.65 40.7383L641.453 41.4134Z",
    stroke: "url(#paint503_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M279.745 38.8187L255.532 26.32L253.729 23.2852L277.942 37.8772L279.745 38.8187Z",
    stroke: "url(#paint504_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M173.867 49.1862L149.655 80.8973L147.846 77.7881L172.065 46.4238L173.867 49.1862Z",
    stroke: "url(#paint505_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M224.102 2.77908L199.883 17.5941L198.08 15.1353L222.293 0.611328L224.102 2.77908Z",
    stroke: "url(#paint506_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M667.475 10.8173L643.256 41.9277L641.453 41.4136L665.666 10.1484L667.475 10.8173Z",
    stroke: "url(#paint507_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M747.33 -6.97661L723.118 1.04408L721.315 0.0345228L745.527 -8.09766L747.33 -6.97661Z",
    stroke: "url(#paint508_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M199.883 17.5936L175.67 51.5778L173.867 49.1871L198.08 15.1348L199.883 17.5936Z",
    stroke: "url(#paint509_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M251.92 20.4922L227.707 7.77675L225.904 5.18164L250.117 17.9776L251.92 20.4922Z",
    stroke: "url(#paint510_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M693.49 -3.01318L669.278 11.3745L667.475 10.8171L691.687 -4.75977L693.49 -3.01318Z",
    stroke: "url(#paint511_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M281.554 39.4631L257.335 29.5472L255.532 26.3203L279.745 38.819L281.554 39.4631Z",
    stroke: "url(#paint512_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M643.256 41.9281L619.043 68.4181L617.24 67.3652L641.453 41.4141L643.256 41.9281Z",
    stroke: "url(#paint513_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M175.67 51.5782L151.457 83.5433L149.654 80.8987L173.867 49.1875L175.67 51.5782Z",
    stroke: "url(#paint514_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M225.905 5.18241L201.692 19.7683L199.883 17.5943L224.102 2.7793L225.905 5.18241Z",
    stroke: "url(#paint515_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M669.278 11.3758L645.065 42.3065L643.256 41.9287L667.475 10.8184L669.278 11.3758Z",
    stroke: "url(#paint516_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M721.315 0.0354996L697.103 -0.50954L695.293 -1.59961L719.512 -1.28374L721.315 0.0354996Z",
    stroke: "url(#paint517_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M201.692 19.7677L177.479 53.6033L175.67 51.578L199.883 17.5938L201.692 19.7677Z",
    stroke: "url(#paint518_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M749.14 -6.12804L724.921 1.72543L723.118 1.04413L747.331 -6.97656L749.14 -6.12804Z",
    stroke: "url(#paint519_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73 23.2861L229.517 10.5335L227.708 7.77734L251.921 20.4928L253.73 23.2861Z",
    stroke: "url(#paint520_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M695.293 -1.59958L671.08 11.8405L669.277 11.376L693.49 -3.01172L695.293 -1.59958Z",
    stroke: "url(#paint521_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M283.357 39.8344L259.144 32.941L257.335 29.5469L281.554 39.4628L283.357 39.8344Z",
    stroke: "url(#paint522_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M177.48 53.6034L153.261 85.7234L151.458 83.5432L175.671 51.5781L177.48 53.6034Z",
    stroke: "url(#paint523_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M645.066 42.3055L620.847 69.3715L619.044 68.4177L643.257 41.9277L645.066 42.3055Z",
    stroke: "url(#paint524_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M227.708 7.77675L203.495 21.6875L201.692 19.7675L225.905 5.18164L227.708 7.77675Z",
    stroke: "url(#paint525_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M312.985 69.3091L288.772 47.7616L286.963 43.2031L311.182 69.1543L312.985 69.3091Z",
    stroke: "url(#paint526_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M671.081 11.8395L646.868 42.5783L645.065 42.3058L669.278 11.375L671.081 11.8395Z",
    stroke: "url(#paint527_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M203.495 21.6876L179.282 55.2754L177.479 53.6031L201.692 19.7676L203.495 21.6876Z",
    stroke: "url(#paint528_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M723.118 1.04482L698.905 0.239653L697.103 -0.509766L721.315 0.0352692L723.118 1.04482Z",
    stroke: "url(#paint529_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M750.943 -5.58191L726.73 2.07335L724.921 1.72651L749.14 -6.12695L750.943 -5.58191Z",
    stroke: "url(#paint530_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M255.532 26.3207L231.32 13.4318L229.517 10.5332L253.729 23.2858L255.532 26.3207Z",
    stroke: "url(#paint531_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M285.16 39.9897L260.947 36.4532L259.145 32.9414L283.357 39.8349L285.16 39.9897Z",
    stroke: "url(#paint532_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M697.103 -0.509542L672.884 12.5527L671.081 11.8405L695.294 -1.59961L697.103 -0.509542Z",
    stroke: "url(#paint533_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M179.282 55.2758L155.07 87.4267L153.261 85.7234L177.48 53.6035L179.282 55.2758Z",
    stroke: "url(#paint534_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M646.868 42.5792L622.656 70.2707L620.847 69.3726L645.065 42.3066L646.868 42.5792Z",
    stroke: "url(#paint535_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M229.517 10.5335L205.298 23.379L203.495 21.6881L227.708 7.77734L229.517 10.5335Z",
    stroke: "url(#paint536_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M314.787 69.272L290.574 52.3635L288.771 47.7617L312.984 69.3092L314.787 69.272Z",
    stroke: "url(#paint537_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M672.884 12.5521L648.671 42.7582L646.868 42.5786L671.081 11.8398L672.884 12.5521Z",
    stroke: "url(#paint538_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M205.298 23.3784L181.085 56.6007L179.282 55.2753L203.495 21.6875L205.298 23.3784Z",
    stroke: "url(#paint539_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M257.335 29.5473L233.122 16.4231L231.319 13.4316L255.532 26.3205L257.335 29.5473Z",
    stroke: "url(#paint540_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M724.921 1.72474L700.708 0.653254L698.905 0.238281L723.118 1.04345L724.921 1.72474Z",
    stroke: "url(#paint541_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M752.746 -5.35907L728.533 2.07323H726.73L750.943 -5.58203L752.746 -5.35907Z",
    stroke: "url(#paint542_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M286.963 43.2041L262.75 40.0516L260.947 36.4531L285.16 39.9897L286.963 43.2041Z",
    stroke: "url(#paint543_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M698.905 0.239658L674.693 15.4697L672.884 12.5525L697.103 -0.509766L698.905 0.239658Z",
    stroke: "url(#paint544_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M181.085 56.6008L156.872 88.6712L155.069 87.4263L179.282 55.2754L181.085 56.6008Z",
    stroke: "url(#paint545_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M316.597 69.1003L292.378 56.9671L290.575 52.3652L314.788 69.2737L316.597 69.1003Z",
    stroke: "url(#paint546_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M231.32 13.4318L207.107 24.8837L205.298 23.3787L229.517 10.5332L231.32 13.4318Z",
    stroke: "url(#paint547_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M648.671 42.7577L624.458 71.1368L622.655 70.2696L646.868 42.5781L648.671 42.7577Z",
    stroke: "url(#paint548_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M259.145 32.9421L234.932 19.4958L233.123 16.4238L257.336 29.548L259.145 32.9421Z",
    stroke: "url(#paint549_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M674.693 15.4699L650.48 42.8827L648.671 42.7589L672.883 12.5527L674.693 15.4699Z",
    stroke: "url(#paint550_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M207.107 24.8839L182.894 57.6109L181.085 56.6013L205.298 23.3789L207.107 24.8839Z",
    stroke: "url(#paint551_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M288.772 47.7618L264.559 43.6926L262.75 40.0508L286.963 43.2033L288.772 47.7618Z",
    stroke: "url(#paint552_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M726.73 2.07262L702.518 1.6143L700.708 0.654297L724.921 1.72578L726.73 2.07262Z",
    stroke: "url(#paint553_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M754.555 -5.47852L730.336 1.73082L728.533 2.07146L752.746 -5.36084L754.555 -5.47852Z",
    stroke: "url(#paint554_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M700.708 0.653255L676.495 18.1749L674.692 15.4683L698.905 0.238281L700.708 0.653255Z",
    stroke: "url(#paint555_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M318.4 68.8523L294.187 61.5005L292.378 56.9668L316.597 69.1L318.4 68.8523Z",
    stroke: "url(#paint556_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M182.895 57.6111L158.676 89.4709L156.873 88.6719L181.086 56.6016L182.895 57.6111Z",
    stroke: "url(#paint557_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M233.123 16.4231L208.91 26.2276L207.107 24.8836L231.32 13.4316L233.123 16.4231Z",
    stroke: "url(#paint558_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M650.481 42.8817L626.262 72.5242L624.459 71.1368L648.672 42.7578L650.481 42.8817Z",
    stroke: "url(#paint559_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M260.947 36.4522L236.735 22.6033L234.932 19.4941L259.144 32.9404L260.947 36.4522Z",
    stroke: "url(#paint560_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M290.575 52.3644L266.363 47.3414L264.56 43.6934L288.772 47.7625L290.575 52.3644Z",
    stroke: "url(#paint561_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M728.533 2.07161L704.32 4.22697L702.518 1.61328L726.73 2.07161H728.533Z",
    stroke: "url(#paint562_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M676.496 18.1753L652.283 42.9621L650.48 42.8816L674.693 15.4688L676.496 18.1753Z",
    stroke: "url(#paint563_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M208.91 26.2268L184.697 58.322L182.895 57.6097L207.107 24.8828L208.91 26.2268Z",
    stroke: "url(#paint564_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M702.518 1.6143L678.299 20.6843L676.496 18.1759L700.709 0.654297L702.518 1.6143Z",
    stroke: "url(#paint565_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M320.202 68.5793L295.989 65.9284L294.187 61.5L318.399 68.8518L320.202 68.5793Z",
    stroke: "url(#paint566_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M184.698 58.3216L160.485 89.8346L158.676 89.4692L182.895 57.6094L184.698 58.3216Z",
    stroke: "url(#paint567_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 19.4958L210.713 27.4546L208.91 26.2283L233.123 16.4238L234.932 19.4958Z",
    stroke: "url(#paint568_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M652.284 42.9633L628.071 74.018L626.262 72.5253L650.481 42.8828L652.284 42.9633Z",
    stroke: "url(#paint569_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M262.75 40.0508L238.537 25.7251L236.734 22.6035L260.947 36.4524L262.75 40.0508Z",
    stroke: "url(#paint570_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M292.378 56.9666L268.165 50.9527L266.362 47.3418L290.575 52.3648L292.378 56.9666Z",
    stroke: "url(#paint571_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M730.336 1.73242L706.123 6.60677L704.32 4.22843L728.533 2.07307L730.336 1.73242Z",
    stroke: "url(#paint572_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M210.713 27.4529L186.5 59.1888L184.697 58.3217L208.91 26.2266L210.713 27.4529Z",
    stroke: "url(#paint573_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M678.299 20.6842L654.086 43.0678L652.283 42.9625L676.496 18.1758L678.299 20.6842Z",
    stroke: "url(#paint574_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M704.321 4.22698L680.108 22.9935L678.299 20.6833L702.518 1.61328L704.321 4.22698Z",
    stroke: "url(#paint575_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M654.086 43.0682L629.873 75.4916L628.07 74.0175L652.283 42.9629L654.086 43.0682Z",
    stroke: "url(#paint576_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M236.735 22.6033L212.522 28.5987L210.713 27.4529L234.932 19.4941L236.735 22.6033Z",
    stroke: "url(#paint577_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M186.5 59.1894L162.287 89.8042L160.484 89.8352L184.697 58.3223L186.5 59.1894Z",
    stroke: "url(#paint578_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M264.559 43.6941L240.34 28.8357L238.537 25.7266L262.75 40.0523L264.559 43.6941Z",
    stroke: "url(#paint579_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M294.187 61.5008L269.974 54.5021L268.165 50.9531L292.378 56.9671L294.187 61.5008Z",
    stroke: "url(#paint580_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M732.145 1.04492L707.933 8.74356L706.124 6.60677L730.336 1.73241L732.145 1.04492Z",
    stroke: "url(#paint581_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M680.108 22.9938L655.895 46.9196L654.086 43.0672L678.299 20.6836L680.108 22.9938Z",
    stroke: "url(#paint582_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M706.123 6.60685L681.91 25.1257L680.107 22.9951L704.32 4.22852L706.123 6.60685Z",
    stroke: "url(#paint583_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M212.522 28.5989L188.303 59.9694L186.5 59.189L210.713 27.4531L212.522 28.5989Z",
    stroke: "url(#paint584_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M655.895 46.9208L631.676 76.9473L629.873 75.4918L654.086 43.0684L655.895 46.9208Z",
    stroke: "url(#paint585_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M238.538 25.7251L214.325 29.689L212.522 28.5989L236.735 22.6035L238.538 25.7251Z",
    stroke: "url(#paint586_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M295.99 65.9291L271.778 57.9394L269.975 54.502L294.187 61.5007L295.99 65.9291Z",
    stroke: "url(#paint587_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M266.363 47.3404L242.15 31.906L240.341 28.834L264.56 43.6924L266.363 47.3404Z",
    stroke: "url(#paint588_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M188.304 59.9699L164.091 89.4142L162.288 89.8044L186.501 59.1895L188.304 59.9699Z",
    stroke: "url(#paint589_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M681.911 25.1247L657.698 51.4908L655.896 46.92L680.108 22.9941L681.911 25.1247Z",
    stroke: "url(#paint590_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M733.948 0.00976562L709.735 10.6627L707.933 8.74271L732.145 1.04409L733.948 0.00976562Z",
    stroke: "url(#paint591_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M707.933 8.74225L683.714 27.0876L681.911 25.1243L706.124 6.60547L707.933 8.74225Z",
    stroke: "url(#paint592_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M214.325 29.6897L190.113 60.5585L188.304 59.9701L212.523 28.5996L214.325 29.6897Z",
    stroke: "url(#paint593_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M297.793 70.2028L273.58 61.253L271.777 57.9395L295.99 65.9292L297.793 70.2028Z",
    stroke: "url(#paint594_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M268.165 50.9515L243.952 34.9101L242.149 31.9062L266.362 47.3407L268.165 50.9515Z",
    stroke: "url(#paint595_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M657.698 51.4908L633.486 78.3648L631.677 76.9464L655.896 46.9199L657.698 51.4908Z",
    stroke: "url(#paint596_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M240.341 28.8357L216.128 30.7681L214.325 29.6904L238.538 25.7266L240.341 28.8357Z",
    stroke: "url(#paint597_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M683.714 27.0884L659.501 55.9567L657.698 51.4911L681.911 25.125L683.714 27.0884Z",
    stroke: "url(#paint598_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M190.113 60.5591L165.9 88.7089L164.091 89.415L188.303 59.9707L190.113 60.5591Z",
    stroke: "url(#paint599_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M735.751 -1.35352L711.538 12.3591L709.735 10.662L733.948 0.0090756L735.751 -1.35352Z",
    stroke: "url(#paint600_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M709.736 10.6622L685.523 30.2463L683.714 27.0876L707.933 8.74219L709.736 10.6622Z",
    stroke: "url(#paint601_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M216.128 30.7671L191.915 60.9918L190.112 60.5583L214.325 29.6895L216.128 30.7671Z",
    stroke: "url(#paint602_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M299.602 74.2771L275.383 64.4045L273.58 61.252L297.793 70.2017L299.602 74.2771Z",
    stroke: "url(#paint603_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M269.974 54.5005L245.755 37.8335L243.952 34.9102L268.165 50.9515L269.974 54.5005Z",
    stroke: "url(#paint604_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M659.501 55.9558L635.288 79.9498L633.485 78.3642L657.698 51.4902L659.501 55.9558Z",
    stroke: "url(#paint605_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M685.523 30.2466L661.304 60.2793L659.501 55.9562L683.714 27.0879L685.523 30.2466Z",
    stroke: "url(#paint606_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M242.15 31.906L217.937 31.8565L216.128 30.7664L240.341 28.834L242.15 31.906Z",
    stroke: "url(#paint607_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M191.915 60.9921L167.702 89.7985L165.899 88.7084L190.112 60.5586L191.915 60.9921Z",
    stroke: "url(#paint608_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M711.538 12.3591L687.325 34.3216L685.522 30.2462L709.735 10.6621L711.538 12.3591Z",
    stroke: "url(#paint609_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M737.56 -3.03711L713.342 13.8652L711.539 12.3601L735.751 -1.35245L737.56 -3.03711Z",
    stroke: "url(#paint610_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M217.937 31.8576L193.718 61.3081L191.915 60.9923L216.128 30.7676L217.937 31.8576Z",
    stroke: "url(#paint611_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M301.405 78.1169L277.192 67.3772L275.383 64.4043L299.602 74.2769L301.405 78.1169Z",
    stroke: "url(#paint612_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M271.778 57.9384L247.565 40.6521L245.756 37.834L269.975 54.5009L271.778 57.9384Z",
    stroke: "url(#paint613_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M687.325 34.3215L663.113 64.4161L661.304 60.2788L685.522 30.2461L687.325 34.3215Z",
    stroke: "url(#paint614_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M661.304 60.2802L637.091 83.4379L635.288 79.951L659.501 55.957L661.304 60.2802Z",
    stroke: "url(#paint615_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M243.953 34.9109L219.74 32.9908L217.938 31.8574L242.15 31.907L243.953 34.9109Z",
    stroke: "url(#paint616_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M713.342 13.8644L689.129 38.2857L687.326 34.3218L711.539 12.3594L713.342 13.8644Z",
    stroke: "url(#paint617_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M193.719 61.3081L169.506 91.0434L167.703 89.7985L191.916 60.9922L193.719 61.3081Z",
    stroke: "url(#paint618_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M739.363 -3.38477L715.15 15.196L713.341 13.8644L737.56 -3.03793L739.363 -3.38477Z",
    stroke: "url(#paint619_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M219.74 32.9908L195.527 61.5371L193.718 61.3079L217.937 31.8574L219.74 32.9908Z",
    stroke: "url(#paint620_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M689.129 38.2862L664.916 68.3313L663.113 64.4169L687.326 34.3223L689.129 38.2862Z",
    stroke: "url(#paint621_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M273.58 61.2522L249.367 43.3589L247.564 40.6523L271.777 57.9387L273.58 61.2522Z",
    stroke: "url(#paint622_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M663.114 64.4166L638.901 86.6949L637.092 83.4371L661.304 60.2793L663.114 64.4166Z",
    stroke: "url(#paint623_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M715.151 15.1969L690.938 42.0894L689.129 38.2865L713.342 13.8652L715.151 15.1969Z",
    stroke: "url(#paint624_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M245.756 37.8336L221.543 34.198L219.74 32.9902L243.953 34.9102L245.756 37.8336Z",
    stroke: "url(#paint625_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M195.528 61.5378L171.309 92.258L169.506 91.044L193.718 61.3086L195.528 61.5378Z",
    stroke: "url(#paint626_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M741.166 -2.29469L716.953 16.3852L715.15 15.196L739.363 -3.38477L741.166 -2.29469Z",
    stroke: "url(#paint627_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M690.938 42.09L666.719 71.9988L664.916 68.3322L689.129 38.2871L690.938 42.09Z",
    stroke: "url(#paint628_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M664.916 68.3323L640.703 89.7126L638.9 86.6963L663.113 64.418L664.916 68.3323Z",
    stroke: "url(#paint629_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M275.383 64.4052L251.17 45.9421L249.367 43.3594L273.58 61.2526L275.383 64.4052Z",
    stroke: "url(#paint630_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M221.543 34.198L197.33 61.7285L195.527 61.5365L219.74 32.9902L221.543 34.198Z",
    stroke: "url(#paint631_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M716.953 16.3864L692.74 45.7007L690.938 42.0898L715.15 15.1973L716.953 16.3864Z",
    stroke: "url(#paint632_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M247.565 40.6529L223.346 35.4937L221.543 34.1992L245.756 37.8349L247.565 40.6529Z",
    stroke: "url(#paint633_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M197.33 61.7291L173.118 93.4836L171.309 92.2573L195.527 61.5371L197.33 61.7291Z",
    stroke: "url(#paint634_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M742.975 -1.41543L718.756 17.4564L716.953 16.3849L741.166 -2.29492L742.975 -1.41543Z",
    stroke: "url(#paint635_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M692.74 45.7007L668.528 75.368L666.719 71.9987L690.938 42.0898L692.74 45.7007Z",
    stroke: "url(#paint636_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M277.193 67.3774L252.98 48.3879L251.171 45.9414L275.383 64.4045L277.193 67.3774Z",
    stroke: "url(#paint637_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M223.346 35.4937L199.133 62.2871L197.33 61.7297L221.543 34.1992L223.346 35.4937Z",
    stroke: "url(#paint638_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M718.756 17.4582L694.544 49.0703L692.741 45.701L716.953 16.3867L718.756 17.4582Z",
    stroke: "url(#paint639_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M249.367 43.358L225.155 36.8919L223.346 35.4922L247.564 40.6514L249.367 43.358Z",
    stroke: "url(#paint640_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M199.134 62.2859L174.921 94.7589L173.118 93.483L197.331 61.7285L199.134 62.2859Z",
    stroke: "url(#paint641_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M770.794 -22.9688L746.581 -0.151592L744.778 -0.709016L768.991 -19.649L770.794 -22.9688Z",
    stroke: "url(#paint642_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M744.778 -0.707994L720.566 18.455L718.756 17.4578L742.975 -1.41406L744.778 -0.707994Z",
    stroke: "url(#paint643_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M694.544 49.0685L670.331 78.4076L668.528 75.3665L692.741 45.6992L694.544 49.0685Z",
    stroke: "url(#paint644_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M278.995 70.1591L254.782 50.6989L252.979 48.3887L277.192 67.3782L278.995 70.1591Z",
    stroke: "url(#paint645_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M225.155 36.8919L200.942 65.017L199.133 62.2856L223.345 35.4922L225.155 36.8919Z",
    stroke: "url(#paint646_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M720.566 18.4542L696.347 52.1597L694.544 49.0691L718.757 17.457L720.566 18.4542Z",
    stroke: "url(#paint647_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M251.171 45.9414L226.958 38.7816L225.155 36.8926L249.368 43.3587L251.171 45.9414Z",
    stroke: "url(#paint648_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M200.943 65.0185L176.724 96.1412L174.921 94.7601L199.134 62.2871L200.943 65.0185Z",
    stroke: "url(#paint649_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M772.603 -23.2344L748.384 0.301238L746.581 -0.150895L770.794 -22.9681L772.603 -23.2344Z",
    stroke: "url(#paint650_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M746.581 -0.151561L722.368 19.4264L720.565 18.454L744.778 -0.708984L746.581 -0.151561Z",
    stroke: "url(#paint651_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M696.347 52.1609L672.134 81.0788L670.331 78.4093L694.544 49.0703L696.347 52.1609Z",
    stroke: "url(#paint652_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M280.798 72.7298L256.585 52.8794L254.782 50.6992L278.995 70.1595L280.798 72.7298Z",
    stroke: "url(#paint653_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M226.958 38.7816L202.745 67.8791L200.942 65.0176L225.155 36.8926L226.958 38.7816Z",
    stroke: "url(#paint654_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M722.368 19.4275L698.156 54.9229L696.347 52.1606L720.565 18.4551L722.368 19.4275Z",
    stroke: "url(#paint655_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M252.98 48.3875L228.761 41.9833L226.958 38.7812L251.171 45.941L252.98 48.3875Z",
    stroke: "url(#paint656_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M698.156 54.9225L673.943 83.3449L672.134 81.078L696.346 52.1602L698.156 54.9225Z",
    stroke: "url(#paint657_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M748.384 0.301743L724.171 20.4123L722.368 19.4275L746.581 -0.150391L748.384 0.301743Z",
    stroke: "url(#paint658_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M774.406 -23.4941L750.193 0.685613L748.384 0.301613L772.603 -23.234L774.406 -23.4941Z",
    stroke: "url(#paint659_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M282.608 75.0953L258.395 54.9414L256.586 52.8789L280.799 72.7294L282.608 75.0953Z",
    stroke: "url(#paint660_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M228.761 41.9833L204.548 70.8764L202.745 67.8787L226.958 38.7812L228.761 41.9833Z",
    stroke: "url(#paint661_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M724.171 20.4125L699.959 57.3139L698.156 54.9232L722.368 19.4277L724.171 20.4125Z",
    stroke: "url(#paint662_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M254.782 50.6988L230.57 45.3723L228.761 41.9844L252.98 48.3885L254.782 50.6988Z",
    stroke: "url(#paint663_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M699.959 57.3126L675.746 85.159L673.943 83.3442L698.156 54.9219L699.959 57.3126Z",
    stroke: "url(#paint664_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M750.193 0.68478L725.981 21.4766L724.171 20.4113L748.384 0.300781L750.193 0.68478Z",
    stroke: "url(#paint665_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M776.208 -23.8906L751.996 1.06332L750.193 0.68551L774.405 -23.4942L776.208 -23.8906Z",
    stroke: "url(#paint666_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M230.57 45.3723L206.357 74.0052L204.548 70.8774L228.76 41.9844L230.57 45.3723Z",
    stroke: "url(#paint667_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M284.41 77.2569L260.197 56.8924L258.395 54.9414L282.607 75.0953L284.41 77.2569Z",
    stroke: "url(#paint668_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M725.981 21.4774L701.762 59.2707L699.959 57.3135L724.172 20.4121L725.981 21.4774Z",
    stroke: "url(#paint669_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M256.586 52.8777L232.373 48.9138L230.57 45.3711L254.783 50.6976L256.586 52.8777Z",
    stroke: "url(#paint670_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M701.762 59.2697L677.549 86.4781L675.746 85.1589L699.959 57.3125L701.762 59.2697Z",
    stroke: "url(#paint671_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M751.996 1.06336L727.783 22.679L725.98 21.4774L750.193 0.685547L751.996 1.06336Z",
    stroke: "url(#paint672_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M232.373 48.9138L208.16 77.2804L206.357 74.004L230.57 45.3711L232.373 48.9138Z",
    stroke: "url(#paint673_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M286.213 79.2204L262 58.7507L260.197 56.8926L284.41 77.2571L286.213 79.2204Z",
    stroke: "url(#paint674_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M727.783 22.6781L703.571 60.7377L701.762 59.2698L725.981 21.4766L727.783 22.6781Z",
    stroke: "url(#paint675_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M258.395 54.9404L234.176 52.5993L232.373 48.9141L256.586 52.878L258.395 54.9404Z",
    stroke: "url(#paint676_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M234.176 52.5992L209.963 80.6934L208.16 77.2807L232.373 48.9141L234.176 52.5992Z",
    stroke: "url(#paint677_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M703.57 60.7374L679.352 87.407L677.549 86.4779L701.761 59.2695L703.57 60.7374Z",
    stroke: "url(#paint678_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M753.799 1.48366L729.586 24.0779L727.783 22.6781L751.996 1.0625L753.799 1.48366Z",
    stroke: "url(#paint679_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M288.022 81.0036L263.803 60.5523L262 58.75L286.213 79.2198L288.022 81.0036Z",
    stroke: "url(#paint680_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M260.197 56.8918L235.985 56.3839L234.176 52.5996L258.395 54.9408L260.197 56.8918Z",
    stroke: "url(#paint681_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M729.586 24.0775L705.374 61.6911L703.571 60.7373L727.783 22.6777L729.586 24.0775Z",
    stroke: "url(#paint682_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M235.985 56.3839L211.766 84.0011L209.963 80.6937L234.175 52.5996L235.985 56.3839Z",
    stroke: "url(#paint683_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M705.373 61.6921L681.161 88.0954L679.352 87.4079L703.57 60.7383L705.373 61.6921Z",
    stroke: "url(#paint684_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M755.608 2.02322L731.396 25.7508L729.586 24.0786L753.799 1.48438L755.608 2.02322Z",
    stroke: "url(#paint685_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M262.001 58.7507L237.788 60.2372L235.985 56.3848L260.198 56.8926L262.001 58.7507Z",
    stroke: "url(#paint686_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M289.825 82.6329L265.613 62.3179L263.804 60.5527L288.023 81.0039L289.825 82.6329Z",
    stroke: "url(#paint687_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M731.395 25.7504L707.176 62.2616L705.374 61.6918L729.586 24.0781L731.395 25.7504Z",
    stroke: "url(#paint688_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M237.788 60.2372L213.576 86.7581L211.767 84.002L235.985 56.3848L237.788 60.2372Z",
    stroke: "url(#paint689_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M263.804 60.5523L239.591 64.0083L237.788 60.2365L262.001 58.75L263.804 60.5523Z",
    stroke: "url(#paint690_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M757.411 2.74189L733.198 27.733L731.396 25.7511L755.608 2.02344L757.411 2.74189Z",
    stroke: "url(#paint691_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M707.177 62.2612L682.964 88.6149L681.161 88.0947L705.374 61.6914L707.177 62.2612Z",
    stroke: "url(#paint692_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M291.628 84.1508L267.415 64.1331L265.612 62.3184L289.825 82.6333L291.628 84.1508Z",
    stroke: "url(#paint693_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M733.198 27.7319L708.986 62.5337L707.177 62.2612L731.396 25.75L733.198 27.7319Z",
    stroke: "url(#paint694_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M239.591 64.0082L215.378 89.0117L213.575 86.7573L237.788 60.2363L239.591 64.0082Z",
    stroke: "url(#paint695_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M265.613 62.3179L241.4 67.409L239.591 64.0088L263.803 60.5527L265.613 62.3179Z",
    stroke: "url(#paint696_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M759.214 3.73936L735.001 29.9754L733.198 27.7333L757.411 2.74219L759.214 3.73936Z",
    stroke: "url(#paint697_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M293.431 85.5874L269.218 66.1643L267.415 64.1328L291.628 84.1505L293.431 85.5874Z",
    stroke: "url(#paint698_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M708.986 62.5342L684.767 89.0118L682.964 88.6154L707.176 62.2617L708.986 62.5342Z",
    stroke: "url(#paint699_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M735.001 29.9745L710.789 62.5837L708.986 62.5342L733.198 27.7324L735.001 29.9745Z",
    stroke: "url(#paint700_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M241.4 67.4081L217.181 90.826L215.378 89.0113L239.591 64.0078L241.4 67.4081Z",
    stroke: "url(#paint701_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M267.416 64.1331L243.203 70.4691L241.4 67.4095L265.613 62.3184L267.416 64.1331Z",
    stroke: "url(#paint702_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M761.023 5.06371L736.804 32.4022L735.001 29.9743L759.214 3.73828L761.023 5.06371Z",
    stroke: "url(#paint703_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M295.24 86.9993L271.028 68.369L269.219 66.1641L293.431 85.5871L295.24 86.9993Z",
    stroke: "url(#paint704_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M710.788 62.5847L686.576 89.7126L684.767 89.0127L708.985 62.5352L710.788 62.5847Z",
    stroke: "url(#paint705_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M736.804 32.4025L712.591 62.4847L710.789 62.5838L735.001 29.9746L736.804 32.4025Z",
    stroke: "url(#paint706_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M269.219 66.1643L245.006 73.225L243.203 70.4689L267.416 64.1328L269.219 66.1643Z",
    stroke: "url(#paint707_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M762.826 6.6624L738.613 34.9671L736.804 32.4029L761.023 5.06445L762.826 6.6624Z",
    stroke: "url(#paint708_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M712.592 62.4844L688.379 92.034L686.576 89.7114L710.789 62.5835L712.592 62.4844Z",
    stroke: "url(#paint709_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M738.614 34.9665L714.401 62.2988L712.592 62.4846L736.804 32.4023L738.614 34.9665Z",
    stroke: "url(#paint710_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M764.629 9.79606L740.416 37.6053L738.613 34.9668L762.826 6.66211L764.629 9.79606Z",
    stroke: "url(#paint711_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M714.401 62.2988L690.182 94.0595L688.379 92.0342L712.591 62.4846L714.401 62.2988Z",
    stroke: "url(#paint712_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M740.416 37.6053L716.204 64.2067L714.401 62.2991L738.613 34.9668L740.416 37.6053Z",
    stroke: "url(#paint713_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M766.438 13.604L742.219 40.2797L740.417 37.6041L764.629 9.79492L766.438 13.604Z",
    stroke: "url(#paint714_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M716.203 64.2065L691.991 95.7752L690.182 94.0595L714.4 62.2988L716.203 64.2065Z",
    stroke: "url(#paint715_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M742.219 40.2811L718.007 66.6286L716.204 64.2069L740.416 37.6055L742.219 40.2811Z",
    stroke: "url(#paint716_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M768.241 17.3712L744.028 42.9507L742.219 40.2812L766.438 13.6055L768.241 17.3712Z",
    stroke: "url(#paint717_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M718.007 66.6287L693.794 97.1569L691.991 95.7757L716.204 64.207L718.007 66.6287Z",
    stroke: "url(#paint718_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M744.029 42.9507L719.81 68.8709L718.007 66.6288L742.219 40.2812L744.029 42.9507Z",
    stroke: "url(#paint719_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M770.044 21.0253L745.831 45.5705L744.028 42.9506L768.241 17.3711L770.044 21.0253Z",
    stroke: "url(#paint720_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M745.831 45.5691L721.619 70.9133L719.81 68.8694L744.028 42.9492L745.831 45.5691Z",
    stroke: "url(#paint721_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M771.847 24.4938L747.634 48.1161L745.831 45.5706L770.044 21.0254L771.847 24.4938Z",
    stroke: "url(#paint722_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M747.634 48.1159L723.422 72.7663L721.619 70.9145L745.831 45.5703L747.634 48.1159Z",
    stroke: "url(#paint723_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M773.656 27.7148L749.443 50.5629L747.634 48.1165L771.847 24.4941L773.656 27.7148Z",
    stroke: "url(#paint724_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M749.444 50.5617L725.225 74.469L723.422 72.7657L747.635 48.1152L749.444 50.5617Z",
    stroke: "url(#paint725_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M775.459 30.6196L751.246 52.9165L749.443 50.563L773.656 27.7148L775.459 30.6196Z",
    stroke: "url(#paint726_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M751.246 52.9161L727.034 75.9872L725.225 74.4697L749.443 50.5625L751.246 52.9161Z",
    stroke: "url(#paint727_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M777.262 33.1585L753.049 55.1396L751.246 52.9161L775.459 30.6191L777.262 33.1585Z",
    stroke: "url(#paint728_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M754.852 57.1826L730.639 78.3584L728.836 77.2869L753.049 55.1387L754.852 57.1826Z",
    stroke: "url(#paint729_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M756.661 59.0355L732.449 79.1894L730.64 78.3594L754.852 57.1836L756.661 59.0355Z",
    stroke: "url(#paint730_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M758.464 60.6579L734.252 79.7713L732.449 79.1891L756.661 59.0352L758.464 60.6579Z",
    stroke: "url(#paint731_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M760.267 62.0456L736.054 80.0999L734.251 79.7716L758.464 60.6582L760.267 62.0456Z",
    stroke: "url(#paint732_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M762.076 63.1845L737.864 80.1983L736.055 80.0992L760.267 62.0449L762.076 63.1845Z",
    stroke: "url(#paint733_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M763.879 64.0693L739.667 80.0673L737.864 80.1974L762.076 63.1836L763.879 64.0693Z",
    stroke: "url(#paint734_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M765.682 64.7206L741.469 81.0841L739.667 80.0683L763.879 64.0703L765.682 64.7206Z",
    stroke: "url(#paint735_linear_136_155408)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_155408",
    x1: 416.83,
    y1: 8.7793,
    x2: 416.83,
    y2: 25.7064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_136_155408",
    x1: 392.614,
    y1: 24.2637,
    x2: 392.614,
    y2: 48.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_136_155408",
    x1: 418.633,
    y1: 6.04883,
    x2: 418.633,
    y2: 27.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_136_155408",
    x1: 420.438,
    y1: 3.01953,
    x2: 420.438,
    y2: 28.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_136_155408",
    x1: 394.42,
    y1: 25.707,
    x2: 394.42,
    y2: 48.1526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_136_155408",
    x1: 422.242,
    y1: -0.255859,
    x2: 422.242,
    y2: 29.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_136_155408",
    x1: 396.227,
    y1: 27.0449,
    x2: 396.227,
    y2: 47.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_136_155408",
    x1: 424.048,
    y1: -1.32227,
    x2: 424.048,
    y2: 30.0916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_136_155408",
    x1: 398.029,
    y1: 28.2461,
    x2: 398.029,
    y2: 47.1303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_136_155408",
    x1: 450.066,
    y1: -21.3262,
    x2: 450.066,
    y2: 0.382339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_136_155408",
    x1: 425.853,
    y1: -1.32227,
    x2: 425.853,
    y2: 30.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_136_155408",
    x1: 399.835,
    y1: 29.2676,
    x2: 399.835,
    y2: 46.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_136_155408",
    x1: 451.872,
    y1: -24.2246,
    x2: 451.872,
    y2: 1.86276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_136_155408",
    x1: 644.833,
    y1: -11.9805,
    x2: 644.833,
    y2: -0.386078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_136_155408",
    x1: 700.48,
    y1: -23.6621,
    x2: 700.48,
    y2: 0.499054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_136_155408",
    x1: 427.656,
    y1: 0.380859,
    x2: 427.656,
    y2: 31.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_136_155408",
    x1: 401.638,
    y1: 30.0918,
    x2: 401.638,
    y2: 45.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_136_155408",
    x1: 646.639,
    y1: -8.79688,
    x2: 646.639,
    y2: 2.85326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_136_155408",
    x1: 453.675,
    y1: -27.2363,
    x2: 453.675,
    y2: 3.08126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_136_155408",
    x1: 674.461,
    y1: -5.16797,
    x2: 674.461,
    y2: 1.01324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_136_155408",
    x1: 702.285,
    y1: -21.3711,
    x2: 702.285,
    y2: 3.12453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_136_155408",
    x1: 349.601,
    y1: 53.7266,
    x2: 349.601,
    y2: 74.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_136_155408",
    x1: 429.463,
    y1: 1.86133,
    x2: 429.463,
    y2: 31.0517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_136_155408",
    x1: 648.442,
    y1: -5.56445,
    x2: 648.442,
    y2: 5.81316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_136_155408",
    x1: 455.481,
    y1: -30.2949,
    x2: 455.481,
    y2: 3.97418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_136_155408",
    x1: 403.444,
    y1: 30.6875,
    x2: 403.444,
    y2: 44.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_136_155408",
    x1: 676.267,
    y1: -2.27539,
    x2: 676.267,
    y2: 4.32697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_136_155408",
    x1: 620.617,
    y1: -6.62891,
    x2: 620.617,
    y2: -0.385773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_136_155408",
    x1: 704.088,
    y1: -19.2891,
    x2: 704.088,
    y2: 5.56579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_136_155408",
    x1: 351.407,
    y1: 51.293,
    x2: 351.407,
    y2: 74.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_136_155408",
    x1: 431.269,
    y1: 3.08203,
    x2: 431.269,
    y2: 31.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_136_155408",
    x1: 650.248,
    y1: -2.28711,
    x2: 650.248,
    y2: 8.45256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_136_155408",
    x1: 678.069,
    y1: 0.5,
    x2: 678.069,
    y2: 7.64739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_136_155408",
    x1: 457.287,
    y1: -33.3496,
    x2: 457.287,
    y2: 4.49319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_136_155408",
    x1: 622.423,
    y1: -3.09375,
    x2: 622.423,
    y2: 2.85209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_136_155408",
    x1: 705.894,
    y1: -17.4551,
    x2: 705.894,
    y2: 7.78377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_136_155408",
    x1: 353.21,
    y1: 48.7656,
    x2: 353.21,
    y2: 74.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_136_155408",
    x1: 652.051,
    y1: 1.01367,
    x2: 652.051,
    y2: 10.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_136_155408",
    x1: 433.071,
    y1: 3.97461,
    x2: 433.071,
    y2: 30.7495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_136_155408",
    x1: 679.876,
    y1: 3.125,
    x2: 679.876,
    y2: 10.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_136_155408",
    x1: 624.23,
    y1: 0.238281,
    x2: 624.23,
    y2: 5.81251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_136_155408",
    x1: 459.09,
    y1: -36.334,
    x2: 459.09,
    y2: 4.58083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_136_155408",
    x1: 707.7,
    y1: -15.9082,
    x2: 707.7,
    y2: 9.59698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_136_155408",
    x1: 355.016,
    y1: 48.4941,
    x2: 355.016,
    y2: 74.1294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_136_155408",
    x1: 653.857,
    y1: 4.32617,
    x2: 653.857,
    y2: 12.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_136_155408",
    x1: 681.682,
    y1: 5.56641,
    x2: 681.682,
    y2: 13.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_136_155408",
    x1: 626.032,
    y1: 3.31641,
    x2: 626.032,
    y2: 8.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_136_155408",
    x1: 434.878,
    y1: 4.49414,
    x2: 434.878,
    y2: 30.0551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_136_155408",
    x1: 709.503,
    y1: -14.6875,
    x2: 709.503,
    y2: 10.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_136_155408",
    x1: 460.896,
    y1: -39.1895,
    x2: 460.896,
    y2: 4.58061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_136_155408",
    x1: 598.207,
    y1: -9.62695,
    x2: 598.207,
    y2: 0.239426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_136_155408",
    x1: 356.822,
    y1: 48.4941,
    x2: 356.822,
    y2: 73.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_136_155408",
    x1: 655.663,
    y1: 7.64648,
    x2: 655.663,
    y2: 14.8682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_136_155408",
    x1: 683.484,
    y1: 7.7832,
    x2: 683.484,
    y2: 16.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_136_155408",
    x1: 627.835,
    y1: 6.09766,
    x2: 627.835,
    y2: 10.7243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_136_155408",
    x1: 436.681,
    y1: 4.17773,
    x2: 436.681,
    y2: 28.9335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_136_155408",
    x1: 711.309,
    y1: -13.8086,
    x2: 711.309,
    y2: 11.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_136_155408",
    x1: 600.014,
    y1: -6.39453,
    x2: 600.014,
    y2: 3.31702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_136_155408",
    x1: 462.699,
    y1: -40.0742,
    x2: 462.699,
    y2: 4.17894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_136_155408",
    x1: 657.466,
    y1: 10.8867,
    x2: 657.466,
    y2: 17.0246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_136_155408",
    x1: 358.625,
    y1: 48.9141,
    x2: 358.625,
    y2: 73.8123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_136_155408",
    x1: 685.291,
    y1: 9.59766,
    x2: 685.291,
    y2: 18.0581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_136_155408",
    x1: 629.645,
    y1: 8.79297,
    x2: 629.645,
    y2: 12.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_136_155408",
    x1: 713.115,
    y1: -13.2324,
    x2: 713.115,
    y2: 12.5886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_136_155408",
    x1: 601.816,
    y1: -3.22266,
    x2: 601.816,
    y2: 6.09868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_136_155408",
    x1: 438.486,
    y1: 3.22461,
    x2: 438.486,
    y2: 27.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_136_155408",
    x1: 464.505,
    y1: -41.0352,
    x2: 464.505,
    y2: 3.22419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_136_155408",
    x1: 659.272,
    y1: 13.7168,
    x2: 659.272,
    y2: 19.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_136_155408",
    x1: 631.447,
    y1: 11.5,
    x2: 631.447,
    y2: 14.8693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_136_155408",
    x1: 687.097,
    y1: 10.9727,
    x2: 687.097,
    y2: 19.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_136_155408",
    x1: 360.431,
    y1: 49.3301,
    x2: 360.431,
    y2: 73.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_136_155408",
    x1: 603.622,
    y1: -0.164063,
    x2: 603.622,
    y2: 8.79185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_136_155408",
    x1: 714.918,
    y1: -12.9102,
    x2: 714.918,
    y2: 12.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_136_155408",
    x1: 466.308,
    y1: -42.4727,
    x2: 466.308,
    y2: 1.66283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_136_155408",
    x1: 661.078,
    y1: 16.1016,
    x2: 661.078,
    y2: 21.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_136_155408",
    x1: 633.25,
    y1: 14.2188,
    x2: 633.25,
    y2: 17.0244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_136_155408",
    x1: 688.9,
    y1: 11.9512,
    x2: 688.9,
    y2: 20.7894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_136_155408",
    x1: 362.237,
    y1: 49.6523,
    x2: 362.237,
    y2: 72.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_136_155408",
    x1: 605.429,
    y1: 2.76562,
    x2: 605.429,
    y2: 11.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_136_155408",
    x1: 716.724,
    y1: -12.8594,
    x2: 716.724,
    y2: 12.9803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_136_155408",
    x1: 577.603,
    y1: -8.36328,
    x2: 577.603,
    y2: -0.162971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_136_155408",
    x1: 662.881,
    y1: 18.0586,
    x2: 662.881,
    y2: 23.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_136_155408",
    x1: 635.06,
    y1: 16.9492,
    x2: 635.06,
    y2: 19.6744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_136_155408",
    x1: 690.705,
    y1: 12.5898,
    x2: 690.705,
    y2: 21.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_136_155408",
    x1: 364.04,
    y1: 49.8008,
    x2: 364.04,
    y2: 72.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_136_155408",
    x1: 607.231,
    y1: 5.5293,
    x2: 607.231,
    y2: 14.2189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_136_155408",
    x1: 718.527,
    y1: -13.0586,
    x2: 718.527,
    y2: 12.9792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_136_155408",
    x1: 579.41,
    y1: -5.89844,
    x2: 579.41,
    y2: 2.76639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_136_155408",
    x1: 664.687,
    y1: 19.6133,
    x2: 664.687,
    y2: 25.8131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_136_155408",
    x1: 636.862,
    y1: 19.2227,
    x2: 636.862,
    y2: 22.3752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_136_155408",
    x1: 692.509,
    y1: 12.918,
    x2: 692.509,
    y2: 22.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_136_155408",
    x1: 365.846,
    y1: 49.6816,
    x2: 365.846,
    y2: 73.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_136_155408",
    x1: 609.037,
    y1: 8.11133,
    x2: 609.037,
    y2: 16.9496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_136_155408",
    x1: 391.864,
    y1: 27.4102,
    x2: 391.864,
    y2: 49.6823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_136_155408",
    x1: 581.213,
    y1: -3.51953,
    x2: 581.213,
    y2: 5.5293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_136_155408",
    x1: 720.333,
    y1: -13.3809,
    x2: 720.333,
    y2: 12.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_136_155408",
    x1: 638.668,
    y1: 21.4336,
    x2: 638.668,
    y2: 25.0259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_136_155408",
    x1: 666.489,
    y1: 20.7891,
    x2: 666.489,
    y2: 27.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_136_155408",
    x1: 694.315,
    y1: 12.8066,
    x2: 694.315,
    y2: 22.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_136_155408",
    x1: 610.844,
    y1: 10.4961,
    x2: 610.844,
    y2: 19.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_136_155408",
    x1: 367.652,
    y1: 49.459,
    x2: 367.652,
    y2: 75.2986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_136_155408",
    x1: 393.667,
    y1: 27.4102,
    x2: 393.667,
    y2: 50.0849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_136_155408",
    x1: 583.019,
    y1: -1.24805,
    x2: 583.019,
    y2: 8.11047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_136_155408",
    x1: 640.471,
    y1: 23.6387,
    x2: 640.471,
    y2: 27.6026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_136_155408",
    x1: 668.296,
    y1: 21.6133,
    x2: 668.296,
    y2: 29.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_136_155408",
    x1: 722.139,
    y1: -13.7832,
    x2: 722.139,
    y2: 12.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_136_155408",
    x1: 612.65,
    y1: 12.6816,
    x2: 612.65,
    y2: 22.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_136_155408",
    x1: 369.455,
    y1: 49.459,
    x2: 369.455,
    y2: 76.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_136_155408",
    x1: 696.12,
    y1: 12.4336,
    x2: 696.12,
    y2: 22.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_136_155408",
    x1: 395.474,
    y1: 27.6699,
    x2: 395.474,
    y2: 51.6143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_136_155408",
    x1: 584.825,
    y1: 0.908203,
    x2: 584.825,
    y2: 10.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_136_155408",
    x1: 642.277,
    y1: 25.8125,
    x2: 642.277,
    y2: 30.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_136_155408",
    x1: 670.102,
    y1: 22.1152,
    x2: 670.102,
    y2: 31.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_136_155408",
    x1: 723.942,
    y1: -14.2715,
    x2: 723.942,
    y2: 11.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_136_155408",
    x1: 614.452,
    y1: 14.6699,
    x2: 614.452,
    y2: 25.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_136_155408",
    x1: 371.261,
    y1: 50.0859,
    x2: 371.261,
    y2: 77.4988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_136_155408",
    x1: 697.924,
    y1: 11.8828,
    x2: 697.924,
    y2: 22.2633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_136_155408",
    x1: 397.279,
    y1: 27.7949,
    x2: 397.279,
    y2: 53.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_136_155408",
    x1: 586.628,
    y1: 2.92773,
    x2: 586.628,
    y2: 12.6826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_136_155408",
    x1: 644.083,
    y1: 27.918,
    x2: 644.083,
    y2: 32.4207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_136_155408",
    x1: 671.904,
    y1: 22.2637,
    x2: 671.904,
    y2: 33.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_136_155408",
    x1: 725.748,
    y1: -14.8184,
    x2: 725.748,
    y2: 11.1885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_136_155408",
    x1: 616.255,
    y1: 16.4473,
    x2: 616.255,
    y2: 27.6019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_136_155408",
    x1: 373.064,
    y1: 51.6152,
    x2: 373.064,
    y2: 78.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_136_155408",
    x1: 699.73,
    y1: 11.1895,
    x2: 699.73,
    y2: 21.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_136_155408",
    x1: 399.082,
    y1: 27.6582,
    x2: 399.082,
    y2: 54.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_136_155408",
    x1: 588.434,
    y1: 4.80469,
    x2: 588.434,
    y2: 14.6711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_136_155408",
    x1: 645.887,
    y1: 29.9258,
    x2: 645.887,
    y2: 34.6019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_136_155408",
    x1: 673.711,
    y1: 21.9727,
    x2: 673.711,
    y2: 35.0225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_136_155408",
    x1: 727.551,
    y1: -15.4238,
    x2: 727.551,
    y2: 10.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_136_155408",
    x1: 618.065,
    y1: 18.0273,
    x2: 618.065,
    y2: 30.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_136_155408",
    x1: 374.87,
    y1: 53.0391,
    x2: 374.87,
    y2: 78.8416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_136_155408",
    x1: 400.889,
    y1: 27.3984,
    x2: 400.889,
    y2: 55.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_136_155408",
    x1: 701.532,
    y1: 10.3711,
    x2: 701.532,
    y2: 21.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_136_155408",
    x1: 590.237,
    y1: 6.53125,
    x2: 590.237,
    y2: 16.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_136_155408",
    x1: 647.692,
    y1: 31.8008,
    x2: 647.692,
    y2: 36.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_136_155408",
    x1: 675.514,
    y1: 21.4824,
    x2: 675.514,
    y2: 36.2975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_136_155408",
    x1: 619.867,
    y1: 19.4141,
    x2: 619.867,
    y2: 32.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_136_155408",
    x1: 729.357,
    y1: -16.0742,
    x2: 729.357,
    y2: 9.44953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_136_155408",
    x1: 376.673,
    y1: 54.3398,
    x2: 376.673,
    y2: 79.1452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_136_155408",
    x1: 402.692,
    y1: 27.002,
    x2: 402.692,
    y2: 56.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_136_155408",
    x1: 592.043,
    y1: 8.09961,
    x2: 592.043,
    y2: 18.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_136_155408",
    x1: 649.495,
    y1: 33.5117,
    x2: 649.495,
    y2: 38.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_136_155408",
    x1: 677.319,
    y1: 20.8086,
    x2: 677.319,
    y2: 37.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_136_155408",
    x1: 621.67,
    y1: 20.623,
    x2: 621.67,
    y2: 34.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_136_155408",
    x1: 731.163,
    y1: -16.7871,
    x2: 731.163,
    y2: 8.43316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_136_155408",
    x1: 378.479,
    y1: 55.5039,
    x2: 378.479,
    y2: 79.1882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_136_155408",
    x1: 651.301,
    y1: 35.0215,
    x2: 651.301,
    y2: 39.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_136_155408",
    x1: 404.497,
    y1: 26.4805,
    x2: 404.497,
    y2: 57.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_136_155408",
    x1: 593.846,
    y1: 9.51172,
    x2: 593.846,
    y2: 19.4153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_136_155408",
    x1: 679.126,
    y1: 19.9902,
    x2: 679.126,
    y2: 38.0383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_136_155408",
    x1: 732.966,
    y1: -17.543,
    x2: 732.966,
    y2: 7.33665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_136_155408",
    x1: 380.285,
    y1: 56.5195,
    x2: 380.285,
    y2: 79.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_136_155408",
    x1: 653.108,
    y1: 36.2988,
    x2: 653.108,
    y2: 41.0741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_136_155408",
    x1: 595.652,
    y1: 10.7676,
    x2: 595.652,
    y2: 20.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_136_155408",
    x1: 406.304,
    y1: 25.8242,
    x2: 406.304,
    y2: 58.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_136_155408",
    x1: 706.947,
    y1: 7.33789,
    x2: 706.947,
    y2: 19.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_136_155408",
    x1: 680.929,
    y1: 19.1172,
    x2: 680.929,
    y2: 38.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_136_155408",
    x1: 654.91,
    y1: 37.3145,
    x2: 654.91,
    y2: 41.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_136_155408",
    x1: 382.088,
    y1: 57.3809,
    x2: 382.088,
    y2: 78.9593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_136_155408",
    x1: 734.772,
    y1: -18.3672,
    x2: 734.772,
    y2: 6.1718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_136_155408",
    x1: 408.107,
    y1: 25.0391,
    x2: 408.107,
    y2: 58.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_136_155408",
    x1: 708.753,
    y1: 6.17187,
    x2: 708.753,
    y2: 19.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_136_155408",
    x1: 682.734,
    y1: 19.1172,
    x2: 682.734,
    y2: 38.5155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_136_155408",
    x1: 434.125,
    y1: -4.13281,
    x2: 434.125,
    y2: 25.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_136_155408",
    x1: 656.716,
    y1: 38.0391,
    x2: 656.716,
    y2: 42.5728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_136_155408",
    x1: 409.912,
    y1: 24.1152,
    x2: 409.912,
    y2: 58.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_136_155408",
    x1: 383.894,
    y1: 58.0684,
    x2: 383.894,
    y2: 78.4638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_136_155408",
    x1: 736.575,
    y1: -19.2578,
    x2: 736.575,
    y2: 4.94671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_136_155408",
    x1: 710.557,
    y1: 4.94531,
    x2: 710.557,
    y2: 19.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_136_155408",
    x1: 684.538,
    y1: 19.2031,
    x2: 684.538,
    y2: 38.5147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_136_155408",
    x1: 435.931,
    y1: -4.93164,
    x2: 435.931,
    y2: 24.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_136_155408",
    x1: 658.519,
    y1: 38.4473,
    x2: 658.519,
    y2: 42.8137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_136_155408",
    x1: 411.718,
    y1: 23.0566,
    x2: 411.718,
    y2: 59.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_136_155408",
    x1: 385.7,
    y1: 58.582,
    x2: 385.7,
    y2: 77.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_136_155408",
    x1: 738.381,
    y1: -20.2305,
    x2: 738.381,
    y2: 3.66438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_136_155408",
    x1: 686.344,
    y1: 18.7402,
    x2: 686.344,
    y2: 38.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_136_155408",
    x1: 712.362,
    y1: 3.66406,
    x2: 712.362,
    y2: 18.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_136_155408",
    x1: 437.737,
    y1: -5.92383,
    x2: 437.737,
    y2: 23.0559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_136_155408",
    x1: 660.325,
    y1: 38.2246,
    x2: 660.325,
    y2: 42.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_136_155408",
    x1: 413.522,
    y1: 21.8613,
    x2: 413.522,
    y2: 59.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_136_155408",
    x1: 387.503,
    y1: 58.918,
    x2: 387.503,
    y2: 76.6626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_136_155408",
    x1: 740.187,
    y1: -21.2891,
    x2: 740.187,
    y2: 2.32707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_136_155408",
    x1: 688.15,
    y1: 17.916,
    x2: 688.15,
    y2: 37.5745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_136_155408",
    x1: 439.54,
    y1: -7.11328,
    x2: 439.54,
    y2: 21.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_136_155408",
    x1: 415.327,
    y1: 20.5234,
    x2: 415.327,
    y2: 59.0475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_136_155408",
    x1: 389.309,
    y1: 59.0469,
    x2: 389.309,
    y2: 75.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_136_155408",
    x1: 741.99,
    y1: -22.4609,
    x2: 741.99,
    y2: 0.926029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_136_155408",
    x1: 689.952,
    y1: 16.7324,
    x2: 689.952,
    y2: 36.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_136_155408",
    x1: 441.346,
    y1: -8.49414,
    x2: 441.346,
    y2: 21.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_136_155408",
    x1: 417.13,
    y1: 20.5234,
    x2: 417.13,
    y2: 58.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_136_155408",
    x1: 443.149,
    y1: -10.0723,
    x2: 443.149,
    y2: 22.2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_136_155408",
    x1: 418.937,
    y1: 21.2852,
    x2: 418.937,
    y2: 58.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_136_155408",
    x1: 444.955,
    y1: -11.8379,
    x2: 444.955,
    y2: 23.1125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_136_155408",
    x1: 420.742,
    y1: 22.2578,
    x2: 420.742,
    y2: 57.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_136_155408",
    x1: 446.761,
    y1: -13.7832,
    x2: 446.761,
    y2: 23.8428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_136_155408",
    x1: 422.545,
    y1: 23.1113,
    x2: 422.545,
    y2: 57.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_136_155408",
    x1: 448.564,
    y1: -15.9023,
    x2: 448.564,
    y2: 24.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_136_155408",
    x1: 424.352,
    y1: 23.8437,
    x2: 424.352,
    y2: 56.3848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_136_155408",
    x1: 450.37,
    y1: -18.168,
    x2: 450.37,
    y2: 24.8279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_136_155408",
    x1: 426.157,
    y1: 24.418,
    x2: 426.157,
    y2: 55.3797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_136_155408",
    x1: 452.176,
    y1: -18.8184,
    x2: 452.176,
    y2: 25.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_136_155408",
    x1: 427.96,
    y1: 24.8281,
    x2: 427.96,
    y2: 54.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_136_155408",
    x1: 453.979,
    y1: -18.8184,
    x2: 453.979,
    y2: 25.0632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_136_155408",
    x1: 429.767,
    y1: 25.0508,
    x2: 429.767,
    y2: 52.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_136_155408",
    x1: 455.785,
    y1: -16.291,
    x2: 455.785,
    y2: 25.0636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_136_155408",
    x1: 431.569,
    y1: 24.8281,
    x2: 431.569,
    y2: 51.5472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_136_155408",
    x1: 457.588,
    y1: -11.4844,
    x2: 457.588,
    y2: 24.8286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_136_155408",
    x1: 433.375,
    y1: 24.3203,
    x2: 433.375,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_136_155408",
    x1: 459.394,
    y1: -6.88281,
    x2: 459.394,
    y2: 26.0175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_136_155408",
    x1: 485.412,
    y1: -23.9043,
    x2: 485.412,
    y2: 1.53275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_136_155408",
    x1: 568.884,
    y1: -4.81445,
    x2: 568.884,
    y2: 1.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_136_155408",
    x1: 461.196,
    y1: -2.5293,
    x2: 461.196,
    y2: 29.2995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_136_155408",
    x1: 435.179,
    y1: 24.3203,
    x2: 435.179,
    y2: 47.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_136_155408",
    x1: 487.216,
    y1: -19.4141,
    x2: 487.216,
    y2: 5.34169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_136_155408",
    x1: 681.982,
    y1: 13.8828,
    x2: 681.982,
    y2: 23.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_136_155408",
    x1: 542.865,
    y1: -8.75977,
    x2: 542.865,
    y2: 1.45965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_136_155408",
    x1: 570.687,
    y1: -1.01172,
    x2: 570.687,
    y2: 2.89024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_136_155408",
    x1: 463.003,
    y1: 1.5332,
    x2: 463.003,
    y2: 32.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_136_155408",
    x1: 489.022,
    y1: -14.8184,
    x2: 489.022,
    y2: 8.98359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_136_155408",
    x1: 436.984,
    y1: 26.0176,
    x2: 436.984,
    y2: 45.5026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_136_155408",
    x1: 683.788,
    y1: 13.1035,
    x2: 683.788,
    y2: 22.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_136_155408",
    x1: 544.668,
    y1: -4.81445,
    x2: 544.668,
    y2: 5.87568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_136_155408",
    x1: 516.846,
    y1: -7.45898,
    x2: 516.846,
    y2: -0.268227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_136_155408",
    x1: 572.492,
    y1: 2.54297,
    x2: 572.492,
    y2: 5.85654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_136_155408",
    x1: 464.809,
    y1: 5.3418,
    x2: 464.809,
    y2: 34.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_136_155408",
    x1: 490.827,
    y1: -10.1348,
    x2: 490.827,
    y2: 12.4347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_136_155408",
    x1: 657.77,
    y1: 22.9941,
    x2: 657.77,
    y2: 27.9924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_136_155408",
    x1: 546.474,
    y1: -1.01172,
    x2: 546.474,
    y2: 10.2358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_136_155408",
    x1: 518.65,
    y1: -2.99414,
    x2: 518.65,
    y2: 4.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_136_155408",
    x1: 685.594,
    y1: 12.2539,
    x2: 685.594,
    y2: 22.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_136_155408",
    x1: 438.79,
    y1: 29.2988,
    x2: 438.79,
    y2: 42.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_136_155408",
    x1: 574.299,
    y1: 4.46875,
    x2: 574.299,
    y2: 8.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_136_155408",
    x1: 466.611,
    y1: 8.98437,
    x2: 466.611,
    y2: 36.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_136_155408",
    x1: 492.631,
    y1: -5.29102,
    x2: 492.631,
    y2: 15.6867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_136_155408",
    x1: 659.575,
    y1: 22.8281,
    x2: 659.575,
    y2: 28.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_136_155408",
    x1: 548.28,
    y1: 2.54297,
    x2: 548.28,
    y2: 14.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_136_155408",
    x1: 520.455,
    y1: 1.45898,
    x2: 520.455,
    y2: 10.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_136_155408",
    x1: 576.102,
    y1: 5.76953,
    x2: 576.102,
    y2: 11.8454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_136_155408",
    x1: 687.397,
    y1: 11.3203,
    x2: 687.397,
    y2: 22.5988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_136_155408",
    x1: 440.594,
    y1: 32.1855,
    x2: 440.594,
    y2: 39.2524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_136_155408",
    x1: 468.418,
    y1: 12.4336,
    x2: 468.418,
    y2: 38.6758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_136_155408",
    x1: 494.437,
    y1: -0.269531,
    x2: 494.437,
    y2: 18.7262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_136_155408",
    x1: 550.083,
    y1: 5.85742,
    x2: 550.083,
    y2: 18.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_136_155408",
    x1: 522.261,
    y1: 5.875,
    x2: 522.261,
    y2: 15.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_136_155408",
    x1: 661.378,
    y1: 22.5977,
    x2: 661.378,
    y2: 28.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_136_155408",
    x1: 577.907,
    y1: 6.82812,
    x2: 577.907,
    y2: 14.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_136_155408",
    x1: 442.4,
    y1: 34.6934,
    x2: 442.4,
    y2: 40.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_136_155408",
    x1: 689.203,
    y1: 10.2793,
    x2: 689.203,
    y2: 22.2887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_136_155408",
    x1: 496.242,
    y1: 4.88477,
    x2: 496.242,
    y2: 21.5393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_136_155408",
    x1: 470.224,
    y1: 15.6855,
    x2: 470.224,
    y2: 40.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_136_155408",
    x1: 416.381,
    y1: 39.1973,
    x2: 416.381,
    y2: 55.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_136_155408",
    x1: 524.065,
    y1: 10.2363,
    x2: 524.065,
    y2: 20.7964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_136_155408",
    x1: 551.889,
    y1: 8.95312,
    x2: 551.889,
    y2: 22.8515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_136_155408",
    x1: 663.185,
    y1: 22.2891,
    x2: 663.185,
    y2: 28.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_136_155408",
    x1: 579.714,
    y1: 7.6582,
    x2: 579.714,
    y2: 17.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_136_155408",
    x1: 444.202,
    y1: 36.8496,
    x2: 444.202,
    y2: 41.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_136_155408",
    x1: 498.046,
    y1: 10.1367,
    x2: 498.046,
    y2: 24.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_136_155408",
    x1: 525.87,
    y1: 14.5215,
    x2: 525.87,
    y2: 26.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_136_155408",
    x1: 691.009,
    y1: 9.12695,
    x2: 691.009,
    y2: 21.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_136_155408",
    x1: 472.027,
    y1: 18.7266,
    x2: 472.027,
    y2: 41.4075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_136_155408",
    x1: 553.695,
    y1: 11.8457,
    x2: 553.695,
    y2: 26.8775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_136_155408",
    x1: 418.184,
    y1: 39.252,
    x2: 418.184,
    y2: 54.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_136_155408",
    x1: 581.517,
    y1: 8.29688,
    x2: 581.517,
    y2: 19.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_136_155408",
    x1: 664.99,
    y1: 21.8848,
    x2: 664.99,
    y2: 28.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_136_155408",
    x1: 446.008,
    y1: 38.6758,
    x2: 446.008,
    y2: 44.9189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_136_155408",
    x1: 527.676,
    y1: 18.7324,
    x2: 527.676,
    y2: 31.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_136_155408",
    x1: 499.852,
    y1: 15.4512,
    x2: 499.852,
    y2: 26.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_136_155408",
    x1: 555.498,
    y1: 14.5586,
    x2: 555.498,
    y2: 30.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_136_155408",
    x1: 473.833,
    y1: 21.5391,
    x2: 473.833,
    y2: 42.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_136_155408",
    x1: 419.989,
    y1: 40.2617,
    x2: 419.989,
    y2: 56.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_136_155408",
    x1: 583.322,
    y1: 8.76758,
    x2: 583.322,
    y2: 21.8608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_136_155408",
    x1: 529.48,
    y1: 22.8516,
    x2: 529.48,
    y2: 36.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_136_155408",
    x1: 447.815,
    y1: 40.1934,
    x2: 447.815,
    y2: 49.3661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_136_155408",
    x1: 666.793,
    y1: 21.3652,
    x2: 666.793,
    y2: 28.3144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_136_155408",
    x1: 501.657,
    y1: 20.7949,
    x2: 501.657,
    y2: 28.5369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_136_155408",
    x1: 557.304,
    y1: 17.1172,
    x2: 557.304,
    y2: 34.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_136_155408",
    x1: 421.796,
    y1: 41.0371,
    x2: 421.796,
    y2: 60.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_136_155408",
    x1: 475.639,
    y1: 24.1152,
    x2: 475.639,
    y2: 43.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_136_155408",
    x1: 531.285,
    y1: 26.877,
    x2: 531.285,
    y2: 42.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_136_155408",
    x1: 585.125,
    y1: 9.10156,
    x2: 585.125,
    y2: 24.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_136_155408",
    x1: 449.62,
    y1: 41.4082,
    x2: 449.62,
    y2: 53.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_136_155408",
    x1: 559.107,
    y1: 19.5391,
    x2: 559.107,
    y2: 38.3304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_136_155408",
    x1: 503.461,
    y1: 26.1523,
    x2: 503.461,
    y2: 31.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_136_155408",
    x1: 423.602,
    y1: 44.9199,
    x2: 423.602,
    y2: 64.6155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_136_155408",
    x1: 477.442,
    y1: 26.4512,
    x2: 477.442,
    y2: 43.5331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_136_155408",
    x1: 533.088,
    y1: 30.8105,
    x2: 533.088,
    y2: 46.9696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_136_155408",
    x1: 395.777,
    y1: 52.123,
    x2: 395.777,
    y2: 56.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_136_155408",
    x1: 451.423,
    y1: 42.3496,
    x2: 451.423,
    y2: 58.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_136_155408",
    x1: 586.932,
    y1: 9.34375,
    x2: 586.932,
    y2: 26.1284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_136_155408",
    x1: 560.913,
    y1: 21.8613,
    x2: 560.913,
    y2: 41.6994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_136_155408",
    x1: 505.267,
    y1: 30.3887,
    x2: 505.267,
    y2: 36.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_136_155408",
    x1: 425.404,
    y1: 49.3672,
    x2: 425.404,
    y2: 68.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_136_155408",
    x1: 534.894,
    y1: 34.6562,
    x2: 534.894,
    y2: 51.5957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_136_155408",
    x1: 479.248,
    y1: 28.5371,
    x2: 479.248,
    y2: 43.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_136_155408",
    x1: 453.23,
    y1: 43.0312,
    x2: 453.23,
    y2: 62.3552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_136_155408",
    x1: 397.58,
    y1: 52.123,
    x2: 397.58,
    y2: 60.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_136_155408",
    x1: 588.734,
    y1: 9.51758,
    x2: 588.734,
    y2: 27.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_136_155408",
    x1: 507.069,
    y1: 34.8047,
    x2: 507.069,
    y2: 42.0264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_136_155408",
    x1: 562.716,
    y1: 24.1035,
    x2: 562.716,
    y2: 44.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_136_155408",
    x1: 427.211,
    y1: 53.7461,
    x2: 427.211,
    y2: 71.5712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_136_155408",
    x1: 536.697,
    y1: 38.3301,
    x2: 536.697,
    y2: 55.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_136_155408",
    x1: 455.032,
    y1: 43.5332,
    x2: 455.032,
    y2: 66.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_136_155408",
    x1: 481.051,
    y1: 30.3887,
    x2: 481.051,
    y2: 44.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_136_155408",
    x1: 399.386,
    y1: 53.002,
    x2: 399.386,
    y2: 64.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_136_155408",
    x1: 616.559,
    y1: 9.46094,
    x2: 616.559,
    y2: 23.8115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_136_155408",
    x1: 508.875,
    y1: 39.5996,
    x2: 508.875,
    y2: 46.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_136_155408",
    x1: 590.54,
    y1: 9.46094,
    x2: 590.54,
    y2: 29.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_136_155408",
    x1: 564.522,
    y1: 26.1289,
    x2: 564.522,
    y2: 47.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_136_155408",
    x1: 429.014,
    y1: 58.0801,
    x2: 429.014,
    y2: 74.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_136_155408",
    x1: 538.503,
    y1: 41.6992,
    x2: 538.503,
    y2: 59.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_136_155408",
    x1: 456.838,
    y1: 43.9785,
    x2: 456.838,
    y2: 70.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_136_155408",
    x1: 510.679,
    y1: 44.1582,
    x2: 510.679,
    y2: 51.5967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_136_155408",
    x1: 618.365,
    y1: 11.7969,
    x2: 618.365,
    y2: 24.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_136_155408",
    x1: 482.857,
    y1: 34.8047,
    x2: 482.857,
    y2: 44.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_136_155408",
    x1: 401.192,
    y1: 55.7461,
    x2: 401.192,
    y2: 68.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_136_155408",
    x1: 592.347,
    y1: 9.46094,
    x2: 592.347,
    y2: 31.0518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_136_155408",
    x1: 566.328,
    y1: 27.9375,
    x2: 566.328,
    y2: 50.2282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_136_155408",
    x1: 430.819,
    y1: 62.3555,
    x2: 430.819,
    y2: 77.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_136_155408",
    x1: 540.309,
    y1: 44.7832,
    x2: 540.309,
    y2: 63.6489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_136_155408",
    x1: 458.642,
    y1: 44.4062,
    x2: 458.642,
    y2: 74.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_136_155408",
    x1: 512.484,
    y1: 48.5,
    x2: 512.484,
    y2: 55.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_136_155408",
    x1: 620.171,
    y1: 14.998,
    x2: 620.171,
    y2: 24.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_136_155408",
    x1: 402.995,
    y1: 58.1309,
    x2: 402.995,
    y2: 71.5709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_136_155408",
    x1: 484.659,
    y1: 39.5996,
    x2: 484.659,
    y2: 45.7127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_136_155408",
    x1: 568.131,
    y1: 29.5605,
    x2: 568.131,
    y2: 52.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_136_155408",
    x1: 594.15,
    y1: 11.7969,
    x2: 594.15,
    y2: 32.4463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_136_155408",
    x1: 542.112,
    y1: 47.6133,
    x2: 542.112,
    y2: 67.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_136_155408",
    x1: 460.447,
    y1: 44.8516,
    x2: 460.447,
    y2: 78.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_136_155408",
    x1: 514.291,
    y1: 52.6191,
    x2: 514.291,
    y2: 59.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_136_155408",
    x1: 621.974,
    y1: 17.9707,
    x2: 621.974,
    y2: 24.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_136_155408",
    x1: 486.466,
    y1: 44.1582,
    x2: 486.466,
    y2: 49.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_136_155408",
    x1: 404.801,
    y1: 60.1992,
    x2: 404.801,
    y2: 74.6798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_136_155408",
    x1: 595.955,
    y1: 14.998,
    x2: 595.955,
    y2: 36.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_136_155408",
    x1: 569.937,
    y1: 31.0527,
    x2: 569.937,
    y2: 54.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_136_155408",
    x1: 375.174,
    y1: 29.5723,
    x2: 375.174,
    y2: 55.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_136_155408",
    x1: 543.918,
    y1: 50.2285,
    x2: 543.918,
    y2: 70.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_136_155408",
    x1: 462.253,
    y1: 45.7129,
    x2: 462.253,
    y2: 82.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_136_155408",
    x1: 516.094,
    y1: 56.5195,
    x2: 516.094,
    y2: 63.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_136_155408",
    x1: 488.272,
    y1: 48.5,
    x2: 488.272,
    y2: 53.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_136_155408",
    x1: 623.78,
    y1: 20.6973,
    x2: 623.78,
    y2: 23.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_136_155408",
    x1: 597.762,
    y1: 17.9707,
    x2: 597.762,
    y2: 40.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_136_155408",
    x1: 406.607,
    y1: 61.9707,
    x2: 406.607,
    y2: 77.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_136_155408",
    x1: 571.743,
    y1: 32.4453,
    x2: 571.743,
    y2: 57.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_136_155408",
    x1: 376.977,
    y1: 31.7344,
    x2: 376.977,
    y2: 58.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_136_155408",
    x1: 545.724,
    y1: 52.6426,
    x2: 545.724,
    y2: 73.3601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_136_155408",
    x1: 464.056,
    y1: 49.5273,
    x2: 464.056,
    y2: 86.0509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_136_155408",
    x1: 517.9,
    y1: 60.2305,
    x2: 517.9,
    y2: 67.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_136_155408",
    x1: 490.074,
    y1: 52.6191,
    x2: 490.074,
    y2: 57.2705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_136_155408",
    x1: 625.586,
    y1: 22.5664,
    x2: 625.586,
    y2: 25.3102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_136_155408",
    x1: 599.565,
    y1: 20.6973,
    x2: 599.565,
    y2: 44.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_136_155408",
    x1: 408.41,
    y1: 63.4824,
    x2: 408.41,
    y2: 80.2051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_136_155408",
    x1: 573.546,
    y1: 36.4961,
    x2: 573.546,
    y2: 59.0903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_136_155408",
    x1: 547.527,
    y1: 54.8984,
    x2: 547.527,
    y2: 76.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_136_155408",
    x1: 465.862,
    y1: 53.3867,
    x2: 465.862,
    y2: 89.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_136_155408",
    x1: 519.705,
    y1: 63.7598,
    x2: 519.705,
    y2: 70.3436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_136_155408",
    x1: 350.957,
    y1: 22.9883,
    x2: 350.957,
    y2: 31.7336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_136_155408",
    x1: 491.881,
    y1: 56.5195,
    x2: 491.881,
    y2: 61.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_136_155408",
    x1: 601.37,
    y1: 23.1484,
    x2: 601.37,
    y2: 47.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_136_155408",
    x1: 627.389,
    y1: 21.4336,
    x2: 627.389,
    y2: 27.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_136_155408",
    x1: 575.352,
    y1: 40.5957,
    x2: 575.352,
    y2: 61.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_136_155408",
    x1: 467.668,
    y1: 57.2695,
    x2: 467.668,
    y2: 92.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_136_155408",
    x1: 549.333,
    y1: 57.041,
    x2: 549.333,
    y2: 78.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_136_155408",
    x1: 352.764,
    y1: 25.6953,
    x2: 352.764,
    y2: 33.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_136_155408",
    x1: 326.745,
    y1: 22.9883,
    x2: 326.745,
    y2: 46.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_136_155408",
    x1: 493.687,
    y1: 60.2305,
    x2: 493.687,
    y2: 64.9624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_136_155408",
    x1: 603.177,
    y1: 25.3105,
    x2: 603.177,
    y2: 50.9024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_136_155408",
    x1: 629.195,
    y1: 19.9961,
    x2: 629.195,
    y2: 28.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_136_155408",
    x1: 577.158,
    y1: 44.3867,
    x2: 577.158,
    y2: 63.1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_136_155408",
    x1: 469.471,
    y1: 61.1348,
    x2: 469.471,
    y2: 96.1099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_136_155408",
    x1: 551.139,
    y1: 59.0898,
    x2: 551.139,
    y2: 81.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_136_155408",
    x1: 354.569,
    y1: 29.1328,
    x2: 354.569,
    y2: 35.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_136_155408",
    x1: 495.489,
    y1: 63.7598,
    x2: 495.489,
    y2: 68.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_136_155408",
    x1: 328.548,
    y1: 25.6953,
    x2: 328.548,
    y2: 49.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_136_155408",
    x1: 604.98,
    y1: 27.1758,
    x2: 604.98,
    y2: 53.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_136_155408",
    x1: 631.001,
    y1: 18.2695,
    x2: 631.001,
    y2: 29.9506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_136_155408",
    x1: 578.961,
    y1: 47.8242,
    x2: 578.961,
    y2: 65.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_136_155408",
    x1: 552.943,
    y1: 61.1035,
    x2: 552.943,
    y2: 84.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_136_155408",
    x1: 356.372,
    y1: 32.6016,
    x2: 356.372,
    y2: 36.7017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_136_155408",
    x1: 330.354,
    y1: 29.1328,
    x2: 330.354,
    y2: 53.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_136_155408",
    x1: 302.529,
    y1: 44.2812,
    x2: 302.529,
    y2: 48.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_136_155408",
    x1: 606.785,
    y1: 28.7227,
    x2: 606.785,
    y2: 55.8382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_136_155408",
    x1: 632.804,
    y1: 16.25,
    x2: 632.804,
    y2: 30.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_136_155408",
    x1: 580.767,
    y1: 50.9023,
    x2: 580.767,
    y2: 67.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_136_155408",
    x1: 554.748,
    y1: 63.1035,
    x2: 554.748,
    y2: 86.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_136_155408",
    x1: 358.179,
    y1: 36.082,
    x2: 358.179,
    y2: 39.5814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_136_155408",
    x1: 332.16,
    y1: 32.6016,
    x2: 332.16,
    y2: 56.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_136_155408",
    x1: 304.335,
    y1: 46.4609,
    x2: 304.335,
    y2: 51.2981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_136_155408",
    x1: 608.592,
    y1: 29.9492,
    x2: 608.592,
    y2: 57.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_136_155408",
    x1: 634.61,
    y1: 13.9766,
    x2: 634.61,
    y2: 31.4363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_136_155408",
    x1: 582.569,
    y1: 53.5781,
    x2: 582.569,
    y2: 69.5018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_136_155408",
    x1: 359.981,
    y1: 37.9883,
    x2: 359.981,
    y2: 43.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_136_155408",
    x1: 333.963,
    y1: 36.082,
    x2: 333.963,
    y2: 60.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_136_155408",
    x1: 306.142,
    y1: 49.9922,
    x2: 306.142,
    y2: 54.0242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_136_155408",
    x1: 610.395,
    y1: 30.8535,
    x2: 610.395,
    y2: 59.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_136_155408",
    x1: 584.376,
    y1: 55.8398,
    x2: 584.376,
    y2: 71.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_136_155408",
    x1: 361.787,
    y1: 39.166,
    x2: 361.787,
    y2: 46.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_136_155408",
    x1: 636.413,
    y1: 11.4609,
    x2: 636.413,
    y2: 31.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_136_155408",
    x1: 335.769,
    y1: 39.5801,
    x2: 335.769,
    y2: 63.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_136_155408",
    x1: 307.944,
    y1: 53.4863,
    x2: 307.944,
    y2: 56.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_136_155408",
    x1: 278.316,
    y1: 25.0449,
    x2: 278.316,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_136_155408",
    x1: 612.197,
    y1: 31.4355,
    x2: 612.197,
    y2: 59.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_136_155408",
    x1: 363.591,
    y1: 40.2676,
    x2: 363.591,
    y2: 50.1092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_136_155408",
    x1: 586.179,
    y1: 57.6602,
    x2: 586.179,
    y2: 74.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_136_155408",
    x1: 337.572,
    y1: 43.0859,
    x2: 337.572,
    y2: 66.7021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_136_155408",
    x1: 638.219,
    y1: 8.75586,
    x2: 638.219,
    y2: 31.7093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_136_155408",
    x1: 309.75,
    y1: 56.6621,
    x2: 309.75,
    y2: 60.2916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_136_155408",
    x1: 280.123,
    y1: 27.1133,
    x2: 280.123,
    y2: 51.2992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_136_155408",
    x1: 614.007,
    y1: 31.6719,
    x2: 614.007,
    y2: 60.3544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_136_155408",
    x1: 365.396,
    y1: 41.3652,
    x2: 365.396,
    y2: 53.6409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_136_155408",
    x1: 587.985,
    y1: 59.0293,
    x2: 587.985,
    y2: 77.3313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_136_155408",
    x1: 339.378,
    y1: 46.5918,
    x2: 339.378,
    y2: 69.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_136_155408",
    x1: 640.025,
    y1: 5.90625,
    x2: 640.025,
    y2: 31.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_136_155408",
    x1: 94.3829,
    y1: 64.6035,
    x2: 94.3829,
    y2: 105.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_136_155408",
    x1: 311.553,
    y1: 59.1777,
    x2: 311.553,
    y2: 63.5628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_136_155408",
    x1: 281.926,
    y1: 29.1504,
    x2: 281.926,
    y2: 54.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_136_155408",
    x1: 367.202,
    y1: 42.498,
    x2: 367.202,
    y2: 57.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_136_155408",
    x1: 615.81,
    y1: 31.4668,
    x2: 615.81,
    y2: 60.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_136_155408",
    x1: 589.791,
    y1: 59.9336,
    x2: 589.791,
    y2: 79.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_136_155408",
    x1: 341.184,
    y1: 50.1094,
    x2: 341.184,
    y2: 72.5178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_136_155408",
    x1: 120.402,
    y1: 47.248,
    x2: 120.402,
    y2: 67.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_136_155408",
    x1: 96.1866,
    y1: 64.6035,
    x2: 96.1866,
    y2: 108.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_136_155408",
    x1: 641.828,
    y1: 4.45703,
    x2: 641.828,
    y2: 33.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_136_155408",
    x1: 313.359,
    y1: 61.543,
    x2: 313.359,
    y2: 66.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_136_155408",
    x1: 254.104,
    y1: 8.97266,
    x2: 254.104,
    y2: 27.1137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_136_155408",
    x1: 283.731,
    y1: 31.1387,
    x2: 283.731,
    y2: 56.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_136_155408",
    x1: 369.006,
    y1: 43.7246,
    x2: 369.006,
    y2: 60.7632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_136_155408",
    x1: 591.594,
    y1: 60.3535,
    x2: 591.594,
    y2: 82.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_136_155408",
    x1: 617.612,
    y1: 31.4668,
    x2: 617.612,
    y2: 60.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_136_155408",
    x1: 342.987,
    y1: 53.6406,
    x2: 342.987,
    y2: 75.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_136_155408",
    x1: 122.205,
    y1: 46.1094,
    x2: 122.205,
    y2: 71.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_136_155408",
    x1: 148.224,
    y1: 26.3008,
    x2: 148.224,
    y2: 51.2919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_136_155408",
    x1: 643.634,
    y1: 4.32031,
    x2: 643.634,
    y2: 35.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_136_155408",
    x1: 315.165,
    y1: 63.7305,
    x2: 315.165,
    y2: 69.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_136_155408",
    x1: 255.907,
    y1: 10.582,
    x2: 255.907,
    y2: 29.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_136_155408",
    x1: 285.535,
    y1: 33.0781,
    x2: 285.535,
    y2: 59.1779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_136_155408",
    x1: 370.811,
    y1: 45.1055,
    x2: 370.811,
    y2: 64.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_136_155408",
    x1: 669.652,
    y1: -6.32617,
    x2: 669.652,
    y2: 5.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_136_155408",
    x1: 593.4,
    y1: 60.4727,
    x2: 593.4,
    y2: 84.4109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_136_155408",
    x1: 124.011,
    y1: 46.1094,
    x2: 124.011,
    y2: 76.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_136_155408",
    x1: 150.029,
    y1: 26.3008,
    x2: 150.029,
    y2: 56.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_136_155408",
    x1: 344.793,
    y1: 57.1895,
    x2: 344.793,
    y2: 77.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_136_155408",
    x1: 619.421,
    y1: 33.7773,
    x2: 619.421,
    y2: 61.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_136_155408",
    x1: 176.048,
    y1: -1.33984,
    x2: 176.048,
    y2: 31.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_136_155408",
    x1: 645.44,
    y1: 4.32031,
    x2: 645.44,
    y2: 37.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_136_155408",
    x1: 257.713,
    y1: 12.2422,
    x2: 257.713,
    y2: 31.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_136_155408",
    x1: 398.637,
    y1: 48.5547,
    x2: 398.637,
    y2: 73.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_136_155408",
    x1: 287.341,
    y1: 34.9355,
    x2: 287.341,
    y2: 61.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_136_155408",
    x1: 372.617,
    y1: 46.6914,
    x2: 372.617,
    y2: 67.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_136_155408",
    x1: 202.067,
    y1: -5.86719,
    x2: 202.067,
    y2: 2.14111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_136_155408",
    x1: 671.459,
    y1: -6.76563,
    x2: 671.459,
    y2: 7.27523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_136_155408",
    x1: 151.833,
    y1: 27.5586,
    x2: 151.833,
    y2: 61.3012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_136_155408",
    x1: 125.814,
    y1: 51.293,
    x2: 125.814,
    y2: 80.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_136_155408",
    x1: 595.206,
    y1: 60.7324,
    x2: 595.206,
    y2: 86.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_136_155408",
    x1: 346.599,
    y1: 60.7637,
    x2: 346.599,
    y2: 79.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_136_155408",
    x1: 229.889,
    y1: -4.35742,
    x2: 229.889,
    y2: 10.5815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_136_155408",
    x1: 177.851,
    y1: -1.33984,
    x2: 177.851,
    y2: 36.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_136_155408",
    x1: 621.225,
    y1: 35.8223,
    x2: 621.225,
    y2: 61.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_136_155408",
    x1: 400.439,
    y1: 52.1602,
    x2: 400.439,
    y2: 74.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_136_155408",
    x1: 647.243,
    y1: 5.86914,
    x2: 647.243,
    y2: 38.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_136_155408",
    x1: 259.519,
    y1: 13.9395,
    x2: 259.519,
    y2: 33.0776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_136_155408",
    x1: 374.421,
    y1: 48.5547,
    x2: 374.421,
    y2: 70.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_136_155408",
    x1: 203.87,
    y1: -5.86719,
    x2: 203.87,
    y2: 5.87585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_136_155408",
    x1: 153.639,
    y1: 31.9062,
    x2: 153.639,
    y2: 65.9586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_136_155408",
    x1: 127.62,
    y1: 56.3848,
    x2: 127.62,
    y2: 83.8471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_136_155408",
    x1: 673.262,
    y1: -7.27344,
    x2: 673.262,
    y2: 8.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_136_155408",
    x1: 597.009,
    y1: 61.1465,
    x2: 597.009,
    y2: 87.9337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_136_155408",
    x1: 179.657,
    y1: 2.14062,
    x2: 179.657,
    y2: 39.8162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_136_155408",
    x1: 348.402,
    y1: 64.2812,
    x2: 348.402,
    y2: 80.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_136_155408",
    x1: 231.694,
    y1: -2.86914,
    x2: 231.694,
    y2: 12.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_136_155408",
    x1: 623.027,
    y1: 37.4941,
    x2: 623.027,
    y2: 63.4019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_136_155408",
    x1: 402.245,
    y1: 56.4707,
    x2: 402.245,
    y2: 76.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_136_155408",
    x1: 649.049,
    y1: 7.27539,
    x2: 649.049,
    y2: 39.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_136_155408",
    x1: 261.322,
    y1: 15.7852,
    x2: 261.322,
    y2: 34.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_136_155408",
    x1: 376.227,
    y1: 52.1602,
    x2: 376.227,
    y2: 74.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_136_155408",
    x1: 205.676,
    y1: -4.35742,
    x2: 205.676,
    y2: 9.27466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_136_155408",
    x1: 155.444,
    y1: 36,
    x2: 155.444,
    y2: 70.2877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_136_155408",
    x1: 129.426,
    y1: 61.3008,
    x2: 129.426,
    y2: 87.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_136_155408",
    x1: 675.067,
    y1: -7.83203,
    x2: 675.067,
    y2: 9.34898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_136_155408",
    x1: 181.463,
    y1: 5.875,
    x2: 181.463,
    y2: 43.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_136_155408",
    x1: 598.815,
    y1: 61.7422,
    x2: 598.815,
    y2: 89.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_136_155408",
    x1: 404.052,
    y1: 60.8496,
    x2: 404.052,
    y2: 79.2507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_136_155408",
    x1: 233.5,
    y1: -1.27734,
    x2: 233.5,
    y2: 13.9403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_136_155408",
    x1: 624.833,
    y1: 38.8184,
    x2: 624.833,
    y2: 64.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_136_155408",
    x1: 263.128,
    y1: 17.9785,
    x2: 263.128,
    y2: 36.5964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_136_155408",
    x1: 650.852,
    y1: 8.41992,
    x2: 650.852,
    y2: 40.7381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_136_155408",
    x1: 378.032,
    y1: 56.4707,
    x2: 378.032,
    y2: 77.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_136_155408",
    x1: 207.481,
    y1: -2.86914,
    x2: 207.481,
    y2: 12.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_136_155408",
    x1: 157.248,
    y1: 39.8164,
    x2: 157.248,
    y2: 74.2465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_136_155408",
    x1: 183.266,
    y1: 9.27539,
    x2: 183.266,
    y2: 46.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_136_155408",
    x1: 676.871,
    y1: -7.83203,
    x2: 676.871,
    y2: 10.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_136_155408",
    x1: 600.617,
    y1: 63.4004,
    x2: 600.617,
    y2: 90.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_136_155408",
    x1: 235.304,
    y1: 0.611328,
    x2: 235.304,
    y2: 15.7856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_136_155408",
    x1: 626.64,
    y1: 39.8848,
    x2: 626.64,
    y2: 66.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_136_155408",
    x1: 264.931,
    y1: 20.4922,
    x2: 264.931,
    y2: 37.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_136_155408",
    x1: 379.835,
    y1: 60.8496,
    x2: 379.835,
    y2: 79.9568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_136_155408",
    x1: 159.054,
    y1: 43.2969,
    x2: 159.054,
    y2: 77.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_136_155408",
    x1: 209.285,
    y1: -1.27734,
    x2: 209.285,
    y2: 15.1356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_136_155408",
    x1: 652.658,
    y1: 9.34961,
    x2: 652.658,
    y2: 41.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_136_155408",
    x1: 732.52,
    y1: -9.46094,
    x2: 732.52,
    y2: 0.0338211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_136_155408",
    x1: 185.072,
    y1: 12.3652,
    x2: 185.072,
    y2: 49.1861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_136_155408",
    x1: 678.677,
    y1: -6.80859,
    x2: 678.677,
    y2: 10.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_136_155408",
    x1: 237.109,
    y1: 2.7793,
    x2: 237.109,
    y2: 17.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_136_155408",
    x1: 628.442,
    y1: 40.7383,
    x2: 628.442,
    y2: 67.3645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_136_155408",
    x1: 266.737,
    y1: 23.2852,
    x2: 266.737,
    y2: 38.8187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_136_155408",
    x1: 160.857,
    y1: 46.4238,
    x2: 160.857,
    y2: 80.8973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_136_155408",
    x1: 211.091,
    y1: 0.611328,
    x2: 211.091,
    y2: 17.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_136_155408",
    x1: 654.464,
    y1: 10.1484,
    x2: 654.464,
    y2: 41.9277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_136_155408",
    x1: 734.323,
    y1: -8.09766,
    x2: 734.323,
    y2: 1.04408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_136_155408",
    x1: 186.875,
    y1: 15.1348,
    x2: 186.875,
    y2: 51.5778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_136_155408",
    x1: 238.912,
    y1: 5.18164,
    x2: 238.912,
    y2: 20.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_136_155408",
    x1: 680.482,
    y1: -4.75977,
    x2: 680.482,
    y2: 11.3745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_136_155408",
    x1: 268.543,
    y1: 26.3203,
    x2: 268.543,
    y2: 39.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_136_155408",
    x1: 630.248,
    y1: 41.4141,
    x2: 630.248,
    y2: 68.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_136_155408",
    x1: 162.662,
    y1: 49.1875,
    x2: 162.662,
    y2: 83.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_136_155408",
    x1: 212.894,
    y1: 2.7793,
    x2: 212.894,
    y2: 19.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_136_155408",
    x1: 656.267,
    y1: 10.8184,
    x2: 656.267,
    y2: 42.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_136_155408",
    x1: 708.304,
    y1: -1.59961,
    x2: 708.304,
    y2: 0.0354996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_136_155408",
    x1: 188.681,
    y1: 17.5937,
    x2: 188.681,
    y2: 53.6033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_136_155408",
    x1: 736.129,
    y1: -6.97656,
    x2: 736.129,
    y2: 1.72543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_136_155408",
    x1: 240.719,
    y1: 7.77734,
    x2: 240.719,
    y2: 23.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_136_155408",
    x1: 682.285,
    y1: -3.01172,
    x2: 682.285,
    y2: 11.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_136_155408",
    x1: 270.346,
    y1: 29.5469,
    x2: 270.346,
    y2: 39.8344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_136_155408",
    x1: 164.469,
    y1: 51.5781,
    x2: 164.469,
    y2: 85.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_136_155408",
    x1: 632.055,
    y1: 41.9277,
    x2: 632.055,
    y2: 69.3715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_136_155408",
    x1: 214.7,
    y1: 5.18164,
    x2: 214.7,
    y2: 21.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_136_155408",
    x1: 299.974,
    y1: 43.2031,
    x2: 299.974,
    y2: 69.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_136_155408",
    x1: 658.073,
    y1: 11.375,
    x2: 658.073,
    y2: 42.5783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_136_155408",
    x1: 190.487,
    y1: 19.7676,
    x2: 190.487,
    y2: 55.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_136_155408",
    x1: 710.11,
    y1: -0.509766,
    x2: 710.11,
    y2: 1.04482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_136_155408",
    x1: 737.932,
    y1: -6.12695,
    x2: 737.932,
    y2: 2.07335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_136_155408",
    x1: 242.524,
    y1: 10.5332,
    x2: 242.524,
    y2: 26.3207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_136_155408",
    x1: 272.152,
    y1: 32.9414,
    x2: 272.152,
    y2: 39.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint533_linear_136_155408",
    x1: 684.092,
    y1: -1.59961,
    x2: 684.092,
    y2: 12.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint534_linear_136_155408",
    x1: 166.272,
    y1: 53.6035,
    x2: 166.272,
    y2: 87.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint535_linear_136_155408",
    x1: 633.858,
    y1: 42.3066,
    x2: 633.858,
    y2: 70.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint536_linear_136_155408",
    x1: 216.506,
    y1: 7.77734,
    x2: 216.506,
    y2: 23.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint537_linear_136_155408",
    x1: 301.779,
    y1: 47.7617,
    x2: 301.779,
    y2: 69.3092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint538_linear_136_155408",
    x1: 659.876,
    y1: 11.8398,
    x2: 659.876,
    y2: 42.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint539_linear_136_155408",
    x1: 192.29,
    y1: 21.6875,
    x2: 192.29,
    y2: 56.6007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint540_linear_136_155408",
    x1: 244.327,
    y1: 13.4316,
    x2: 244.327,
    y2: 29.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint541_linear_136_155408",
    x1: 711.913,
    y1: 0.238281,
    x2: 711.913,
    y2: 1.72474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint542_linear_136_155408",
    x1: 739.738,
    y1: -5.58203,
    x2: 739.738,
    y2: 2.07323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint543_linear_136_155408",
    x1: 273.955,
    y1: 36.4531,
    x2: 273.955,
    y2: 43.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint544_linear_136_155408",
    x1: 685.895,
    y1: -0.509766,
    x2: 685.895,
    y2: 15.4697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint545_linear_136_155408",
    x1: 168.077,
    y1: 55.2754,
    x2: 168.077,
    y2: 88.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint546_linear_136_155408",
    x1: 303.586,
    y1: 52.3652,
    x2: 303.586,
    y2: 69.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint547_linear_136_155408",
    x1: 218.309,
    y1: 10.5332,
    x2: 218.309,
    y2: 24.8837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint548_linear_136_155408",
    x1: 635.663,
    y1: 42.5781,
    x2: 635.663,
    y2: 71.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint549_linear_136_155408",
    x1: 246.134,
    y1: 16.4238,
    x2: 246.134,
    y2: 32.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint550_linear_136_155408",
    x1: 661.682,
    y1: 12.5527,
    x2: 661.682,
    y2: 42.8827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint551_linear_136_155408",
    x1: 194.096,
    y1: 23.3789,
    x2: 194.096,
    y2: 57.6109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint552_linear_136_155408",
    x1: 275.761,
    y1: 40.0508,
    x2: 275.761,
    y2: 47.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint553_linear_136_155408",
    x1: 713.719,
    y1: 0.654297,
    x2: 713.719,
    y2: 2.07262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint554_linear_136_155408",
    x1: 741.544,
    y1: -5.47852,
    x2: 741.544,
    y2: 2.07146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint555_linear_136_155408",
    x1: 687.7,
    y1: 0.238281,
    x2: 687.7,
    y2: 18.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint556_linear_136_155408",
    x1: 305.389,
    y1: 56.9668,
    x2: 305.389,
    y2: 69.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint557_linear_136_155408",
    x1: 169.884,
    y1: 56.6016,
    x2: 169.884,
    y2: 89.4709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint558_linear_136_155408",
    x1: 220.115,
    y1: 13.4316,
    x2: 220.115,
    y2: 26.2276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint559_linear_136_155408",
    x1: 637.47,
    y1: 42.7578,
    x2: 637.47,
    y2: 72.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint560_linear_136_155408",
    x1: 247.939,
    y1: 19.4941,
    x2: 247.939,
    y2: 36.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint561_linear_136_155408",
    x1: 277.567,
    y1: 43.6934,
    x2: 277.567,
    y2: 52.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint562_linear_136_155408",
    x1: 715.525,
    y1: 1.61328,
    x2: 715.525,
    y2: 4.22697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint563_linear_136_155408",
    x1: 663.488,
    y1: 15.4687,
    x2: 663.488,
    y2: 42.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint564_linear_136_155408",
    x1: 195.902,
    y1: 24.8828,
    x2: 195.902,
    y2: 58.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint565_linear_136_155408",
    x1: 689.507,
    y1: 0.654297,
    x2: 689.507,
    y2: 20.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint566_linear_136_155408",
    x1: 307.194,
    y1: 61.5,
    x2: 307.194,
    y2: 68.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint567_linear_136_155408",
    x1: 171.687,
    y1: 57.6094,
    x2: 171.687,
    y2: 89.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint568_linear_136_155408",
    x1: 221.921,
    y1: 16.4238,
    x2: 221.921,
    y2: 27.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint569_linear_136_155408",
    x1: 639.273,
    y1: 42.8828,
    x2: 639.273,
    y2: 74.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint570_linear_136_155408",
    x1: 249.742,
    y1: 22.6035,
    x2: 249.742,
    y2: 40.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint571_linear_136_155408",
    x1: 279.37,
    y1: 47.3418,
    x2: 279.37,
    y2: 56.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint572_linear_136_155408",
    x1: 717.328,
    y1: 1.73242,
    x2: 717.328,
    y2: 6.60677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint573_linear_136_155408",
    x1: 197.705,
    y1: 26.2266,
    x2: 197.705,
    y2: 59.1888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint574_linear_136_155408",
    x1: 665.291,
    y1: 18.1758,
    x2: 665.291,
    y2: 43.0678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint575_linear_136_155408",
    x1: 691.31,
    y1: 1.61328,
    x2: 691.31,
    y2: 22.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint576_linear_136_155408",
    x1: 641.078,
    y1: 42.9629,
    x2: 641.078,
    y2: 75.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint577_linear_136_155408",
    x1: 223.724,
    y1: 19.4941,
    x2: 223.724,
    y2: 28.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint578_linear_136_155408",
    x1: 173.492,
    y1: 58.3223,
    x2: 173.492,
    y2: 89.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint579_linear_136_155408",
    x1: 251.548,
    y1: 25.7266,
    x2: 251.548,
    y2: 43.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint580_linear_136_155408",
    x1: 281.176,
    y1: 50.9531,
    x2: 281.176,
    y2: 61.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint581_linear_136_155408",
    x1: 719.134,
    y1: 1.04492,
    x2: 719.134,
    y2: 8.74356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint582_linear_136_155408",
    x1: 667.097,
    y1: 20.6836,
    x2: 667.097,
    y2: 46.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint583_linear_136_155408",
    x1: 693.115,
    y1: 4.22852,
    x2: 693.115,
    y2: 25.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint584_linear_136_155408",
    x1: 199.511,
    y1: 27.4531,
    x2: 199.511,
    y2: 59.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint585_linear_136_155408",
    x1: 642.884,
    y1: 43.0684,
    x2: 642.884,
    y2: 76.9473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint586_linear_136_155408",
    x1: 225.53,
    y1: 22.6035,
    x2: 225.53,
    y2: 29.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint587_linear_136_155408",
    x1: 282.982,
    y1: 54.502,
    x2: 282.982,
    y2: 65.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint588_linear_136_155408",
    x1: 253.352,
    y1: 28.834,
    x2: 253.352,
    y2: 47.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint589_linear_136_155408",
    x1: 175.296,
    y1: 59.1895,
    x2: 175.296,
    y2: 89.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint590_linear_136_155408",
    x1: 668.903,
    y1: 22.9941,
    x2: 668.903,
    y2: 51.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint591_linear_136_155408",
    x1: 720.94,
    y1: 0.00976562,
    x2: 720.94,
    y2: 10.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint592_linear_136_155408",
    x1: 694.922,
    y1: 6.60547,
    x2: 694.922,
    y2: 27.0876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint593_linear_136_155408",
    x1: 201.315,
    y1: 28.5996,
    x2: 201.315,
    y2: 60.5585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint594_linear_136_155408",
    x1: 284.785,
    y1: 57.9395,
    x2: 284.785,
    y2: 70.2028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint595_linear_136_155408",
    x1: 255.157,
    y1: 31.9062,
    x2: 255.157,
    y2: 50.9515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint596_linear_136_155408",
    x1: 644.688,
    y1: 46.9199,
    x2: 644.688,
    y2: 78.3648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint597_linear_136_155408",
    x1: 227.333,
    y1: 25.7266,
    x2: 227.333,
    y2: 30.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint598_linear_136_155408",
    x1: 670.706,
    y1: 25.125,
    x2: 670.706,
    y2: 55.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint599_linear_136_155408",
    x1: 177.102,
    y1: 59.9707,
    x2: 177.102,
    y2: 89.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint600_linear_136_155408",
    x1: 722.743,
    y1: -1.35352,
    x2: 722.743,
    y2: 12.3591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint601_linear_136_155408",
    x1: 696.725,
    y1: 8.74219,
    x2: 696.725,
    y2: 30.2463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint602_linear_136_155408",
    x1: 203.12,
    y1: 29.6895,
    x2: 203.12,
    y2: 60.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint603_linear_136_155408",
    x1: 286.591,
    y1: 61.252,
    x2: 286.591,
    y2: 74.2771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint604_linear_136_155408",
    x1: 256.963,
    y1: 34.9102,
    x2: 256.963,
    y2: 54.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint605_linear_136_155408",
    x1: 646.493,
    y1: 51.4902,
    x2: 646.493,
    y2: 79.9498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint606_linear_136_155408",
    x1: 672.512,
    y1: 27.0879,
    x2: 672.512,
    y2: 60.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint607_linear_136_155408",
    x1: 229.139,
    y1: 28.834,
    x2: 229.139,
    y2: 31.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint608_linear_136_155408",
    x1: 178.907,
    y1: 60.5586,
    x2: 178.907,
    y2: 89.7985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint609_linear_136_155408",
    x1: 698.53,
    y1: 10.6621,
    x2: 698.53,
    y2: 34.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint610_linear_136_155408",
    x1: 724.549,
    y1: -3.03711,
    x2: 724.549,
    y2: 13.8652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint611_linear_136_155408",
    x1: 204.926,
    y1: 30.7676,
    x2: 204.926,
    y2: 61.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint612_linear_136_155408",
    x1: 288.394,
    y1: 64.4043,
    x2: 288.394,
    y2: 78.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint613_linear_136_155408",
    x1: 258.767,
    y1: 37.834,
    x2: 258.767,
    y2: 57.9384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint614_linear_136_155408",
    x1: 674.315,
    y1: 30.2461,
    x2: 674.315,
    y2: 64.4161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint615_linear_136_155408",
    x1: 648.296,
    y1: 55.957,
    x2: 648.296,
    y2: 83.4379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint616_linear_136_155408",
    x1: 230.945,
    y1: 31.8574,
    x2: 230.945,
    y2: 34.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint617_linear_136_155408",
    x1: 700.334,
    y1: 12.3594,
    x2: 700.334,
    y2: 38.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint618_linear_136_155408",
    x1: 180.711,
    y1: 60.9922,
    x2: 180.711,
    y2: 91.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint619_linear_136_155408",
    x1: 726.352,
    y1: -3.38477,
    x2: 726.352,
    y2: 15.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint620_linear_136_155408",
    x1: 206.729,
    y1: 31.8574,
    x2: 206.729,
    y2: 61.5371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint621_linear_136_155408",
    x1: 676.121,
    y1: 34.3223,
    x2: 676.121,
    y2: 68.3313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint622_linear_136_155408",
    x1: 260.572,
    y1: 40.6523,
    x2: 260.572,
    y2: 61.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint623_linear_136_155408",
    x1: 650.103,
    y1: 60.2793,
    x2: 650.103,
    y2: 86.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint624_linear_136_155408",
    x1: 702.14,
    y1: 13.8652,
    x2: 702.14,
    y2: 42.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint625_linear_136_155408",
    x1: 232.748,
    y1: 32.9902,
    x2: 232.748,
    y2: 37.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint626_linear_136_155408",
    x1: 182.517,
    y1: 61.3086,
    x2: 182.517,
    y2: 92.2579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint627_linear_136_155408",
    x1: 728.158,
    y1: -3.38477,
    x2: 728.158,
    y2: 16.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint628_linear_136_155408",
    x1: 677.927,
    y1: 38.2871,
    x2: 677.927,
    y2: 71.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint629_linear_136_155408",
    x1: 651.908,
    y1: 64.418,
    x2: 651.908,
    y2: 89.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint630_linear_136_155408",
    x1: 262.375,
    y1: 43.3594,
    x2: 262.375,
    y2: 64.4052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint631_linear_136_155408",
    x1: 208.535,
    y1: 32.9902,
    x2: 208.535,
    y2: 61.7285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint632_linear_136_155408",
    x1: 703.945,
    y1: 15.1973,
    x2: 703.945,
    y2: 45.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint633_linear_136_155408",
    x1: 234.554,
    y1: 34.1992,
    x2: 234.554,
    y2: 40.6529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint634_linear_136_155408",
    x1: 184.319,
    y1: 61.5371,
    x2: 184.319,
    y2: 93.4836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint635_linear_136_155408",
    x1: 729.964,
    y1: -2.29492,
    x2: 729.964,
    y2: 17.4564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint636_linear_136_155408",
    x1: 679.73,
    y1: 42.0898,
    x2: 679.73,
    y2: 75.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint637_linear_136_155408",
    x1: 264.182,
    y1: 45.9414,
    x2: 264.182,
    y2: 67.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint638_linear_136_155408",
    x1: 210.338,
    y1: 34.1992,
    x2: 210.338,
    y2: 62.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint639_linear_136_155408",
    x1: 705.748,
    y1: 16.3867,
    x2: 705.748,
    y2: 49.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint640_linear_136_155408",
    x1: 236.357,
    y1: 35.4922,
    x2: 236.357,
    y2: 43.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint641_linear_136_155408",
    x1: 186.126,
    y1: 61.7285,
    x2: 186.126,
    y2: 94.7589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint642_linear_136_155408",
    x1: 757.786,
    y1: -22.9688,
    x2: 757.786,
    y2: -0.151592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint643_linear_136_155408",
    x1: 731.767,
    y1: -1.41406,
    x2: 731.767,
    y2: 18.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint644_linear_136_155408",
    x1: 681.536,
    y1: 45.6992,
    x2: 681.536,
    y2: 78.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint645_linear_136_155408",
    x1: 265.987,
    y1: 48.3887,
    x2: 265.987,
    y2: 70.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint646_linear_136_155408",
    x1: 212.144,
    y1: 35.4922,
    x2: 212.144,
    y2: 65.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint647_linear_136_155408",
    x1: 707.555,
    y1: 17.457,
    x2: 707.555,
    y2: 52.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint648_linear_136_155408",
    x1: 238.163,
    y1: 36.8926,
    x2: 238.163,
    y2: 45.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint649_linear_136_155408",
    x1: 187.932,
    y1: 62.2871,
    x2: 187.932,
    y2: 96.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint650_linear_136_155408",
    x1: 759.592,
    y1: -23.2344,
    x2: 759.592,
    y2: 0.301239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint651_linear_136_155408",
    x1: 733.573,
    y1: -0.708984,
    x2: 733.573,
    y2: 19.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint652_linear_136_155408",
    x1: 683.339,
    y1: 49.0703,
    x2: 683.339,
    y2: 81.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint653_linear_136_155408",
    x1: 267.79,
    y1: 50.6992,
    x2: 267.79,
    y2: 72.7298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint654_linear_136_155408",
    x1: 213.95,
    y1: 36.8926,
    x2: 213.95,
    y2: 67.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint655_linear_136_155408",
    x1: 709.358,
    y1: 18.4551,
    x2: 709.358,
    y2: 54.9229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint656_linear_136_155408",
    x1: 239.969,
    y1: 38.7812,
    x2: 239.969,
    y2: 48.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint657_linear_136_155408",
    x1: 685.145,
    y1: 52.1602,
    x2: 685.145,
    y2: 83.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint658_linear_136_155408",
    x1: 735.376,
    y1: -0.150391,
    x2: 735.376,
    y2: 20.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint659_linear_136_155408",
    x1: 761.395,
    y1: -23.4941,
    x2: 761.395,
    y2: 0.685612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint660_linear_136_155408",
    x1: 269.597,
    y1: 52.8789,
    x2: 269.597,
    y2: 75.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint661_linear_136_155408",
    x1: 215.753,
    y1: 38.7812,
    x2: 215.753,
    y2: 70.8764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint662_linear_136_155408",
    x1: 711.164,
    y1: 19.4277,
    x2: 711.164,
    y2: 57.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint663_linear_136_155408",
    x1: 241.772,
    y1: 41.9844,
    x2: 241.772,
    y2: 50.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint664_linear_136_155408",
    x1: 686.951,
    y1: 54.9219,
    x2: 686.951,
    y2: 85.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint665_linear_136_155408",
    x1: 737.182,
    y1: 0.300781,
    x2: 737.182,
    y2: 21.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint666_linear_136_155408",
    x1: 763.201,
    y1: -23.8906,
    x2: 763.201,
    y2: 1.06332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint667_linear_136_155408",
    x1: 217.559,
    y1: 41.9844,
    x2: 217.559,
    y2: 74.0052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint668_linear_136_155408",
    x1: 271.402,
    y1: 54.9414,
    x2: 271.402,
    y2: 77.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint669_linear_136_155408",
    x1: 712.97,
    y1: 20.4121,
    x2: 712.97,
    y2: 59.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint670_linear_136_155408",
    x1: 243.578,
    y1: 45.3711,
    x2: 243.578,
    y2: 52.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint671_linear_136_155408",
    x1: 688.754,
    y1: 57.3125,
    x2: 688.754,
    y2: 86.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint672_linear_136_155408",
    x1: 738.988,
    y1: 0.685547,
    x2: 738.988,
    y2: 22.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint673_linear_136_155408",
    x1: 219.365,
    y1: 45.3711,
    x2: 219.365,
    y2: 77.2804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint674_linear_136_155408",
    x1: 273.205,
    y1: 56.8926,
    x2: 273.205,
    y2: 79.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint675_linear_136_155408",
    x1: 714.773,
    y1: 21.4766,
    x2: 714.773,
    y2: 60.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint676_linear_136_155408",
    x1: 245.384,
    y1: 48.9141,
    x2: 245.384,
    y2: 54.9404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint677_linear_136_155408",
    x1: 221.168,
    y1: 48.9141,
    x2: 221.168,
    y2: 80.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint678_linear_136_155408",
    x1: 690.56,
    y1: 59.2695,
    x2: 690.56,
    y2: 87.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint679_linear_136_155408",
    x1: 740.791,
    y1: 1.0625,
    x2: 740.791,
    y2: 24.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint680_linear_136_155408",
    x1: 275.011,
    y1: 58.75,
    x2: 275.011,
    y2: 81.0036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint681_linear_136_155408",
    x1: 247.187,
    y1: 52.5996,
    x2: 247.187,
    y2: 56.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint682_linear_136_155408",
    x1: 716.579,
    y1: 22.6777,
    x2: 716.579,
    y2: 61.6911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint683_linear_136_155408",
    x1: 222.974,
    y1: 52.5996,
    x2: 222.974,
    y2: 84.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint684_linear_136_155408",
    x1: 692.362,
    y1: 60.7383,
    x2: 692.362,
    y2: 88.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint685_linear_136_155408",
    x1: 742.597,
    y1: 1.48437,
    x2: 742.597,
    y2: 25.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint686_linear_136_155408",
    x1: 248.993,
    y1: 56.3848,
    x2: 248.993,
    y2: 60.2372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint687_linear_136_155408",
    x1: 276.815,
    y1: 60.5527,
    x2: 276.815,
    y2: 82.6329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint688_linear_136_155408",
    x1: 718.384,
    y1: 24.0781,
    x2: 718.384,
    y2: 62.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint689_linear_136_155408",
    x1: 224.777,
    y1: 56.3848,
    x2: 224.777,
    y2: 86.7581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint690_linear_136_155408",
    x1: 250.796,
    y1: 58.75,
    x2: 250.796,
    y2: 64.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint691_linear_136_155408",
    x1: 744.403,
    y1: 2.02344,
    x2: 744.403,
    y2: 27.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint692_linear_136_155408",
    x1: 694.169,
    y1: 61.6914,
    x2: 694.169,
    y2: 88.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint693_linear_136_155408",
    x1: 278.62,
    y1: 62.3184,
    x2: 278.62,
    y2: 84.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint694_linear_136_155408",
    x1: 720.188,
    y1: 25.75,
    x2: 720.188,
    y2: 62.5337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint695_linear_136_155408",
    x1: 226.583,
    y1: 60.2363,
    x2: 226.583,
    y2: 89.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint696_linear_136_155408",
    x1: 252.602,
    y1: 60.5527,
    x2: 252.602,
    y2: 67.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint697_linear_136_155408",
    x1: 746.206,
    y1: 2.74219,
    x2: 746.206,
    y2: 29.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint698_linear_136_155408",
    x1: 280.423,
    y1: 64.1328,
    x2: 280.423,
    y2: 85.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint699_linear_136_155408",
    x1: 695.975,
    y1: 62.2617,
    x2: 695.975,
    y2: 89.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint700_linear_136_155408",
    x1: 721.994,
    y1: 27.7324,
    x2: 721.994,
    y2: 62.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint701_linear_136_155408",
    x1: 228.389,
    y1: 64.0078,
    x2: 228.389,
    y2: 90.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint702_linear_136_155408",
    x1: 254.408,
    y1: 62.3184,
    x2: 254.408,
    y2: 70.4691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint703_linear_136_155408",
    x1: 748.012,
    y1: 3.73828,
    x2: 748.012,
    y2: 32.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint704_linear_136_155408",
    x1: 282.23,
    y1: 66.1641,
    x2: 282.23,
    y2: 86.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint705_linear_136_155408",
    x1: 697.777,
    y1: 62.5352,
    x2: 697.777,
    y2: 89.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint706_linear_136_155408",
    x1: 723.796,
    y1: 29.9746,
    x2: 723.796,
    y2: 62.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint707_linear_136_155408",
    x1: 256.211,
    y1: 64.1328,
    x2: 256.211,
    y2: 73.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint708_linear_136_155408",
    x1: 749.815,
    y1: 5.06445,
    x2: 749.815,
    y2: 34.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint709_linear_136_155408",
    x1: 699.584,
    y1: 62.4844,
    x2: 699.584,
    y2: 92.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint710_linear_136_155408",
    x1: 725.603,
    y1: 32.4023,
    x2: 725.603,
    y2: 62.4846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint711_linear_136_155408",
    x1: 751.621,
    y1: 6.66211,
    x2: 751.621,
    y2: 37.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint712_linear_136_155408",
    x1: 701.39,
    y1: 62.2988,
    x2: 701.39,
    y2: 94.0595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint713_linear_136_155408",
    x1: 727.409,
    y1: 34.9668,
    x2: 727.409,
    y2: 64.2067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint714_linear_136_155408",
    x1: 753.427,
    y1: 9.79492,
    x2: 753.427,
    y2: 40.2797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint715_linear_136_155408",
    x1: 703.193,
    y1: 62.2988,
    x2: 703.193,
    y2: 95.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint716_linear_136_155408",
    x1: 729.211,
    y1: 37.6055,
    x2: 729.211,
    y2: 66.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint717_linear_136_155408",
    x1: 755.23,
    y1: 13.6055,
    x2: 755.23,
    y2: 42.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint718_linear_136_155408",
    x1: 704.999,
    y1: 64.207,
    x2: 704.999,
    y2: 97.1569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint719_linear_136_155408",
    x1: 731.018,
    y1: 40.2812,
    x2: 731.018,
    y2: 68.8709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint720_linear_136_155408",
    x1: 757.036,
    y1: 17.3711,
    x2: 757.036,
    y2: 45.5705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint721_linear_136_155408",
    x1: 732.82,
    y1: 42.9492,
    x2: 732.82,
    y2: 70.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint722_linear_136_155408",
    x1: 758.839,
    y1: 21.0254,
    x2: 758.839,
    y2: 48.1161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint723_linear_136_155408",
    x1: 734.626,
    y1: 45.5703,
    x2: 734.626,
    y2: 72.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint724_linear_136_155408",
    x1: 760.645,
    y1: 24.4941,
    x2: 760.645,
    y2: 50.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint725_linear_136_155408",
    x1: 736.433,
    y1: 48.1152,
    x2: 736.433,
    y2: 74.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint726_linear_136_155408",
    x1: 762.451,
    y1: 27.7148,
    x2: 762.451,
    y2: 52.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint727_linear_136_155408",
    x1: 738.235,
    y1: 50.5625,
    x2: 738.235,
    y2: 75.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint728_linear_136_155408",
    x1: 764.254,
    y1: 30.6191,
    x2: 764.254,
    y2: 55.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint729_linear_136_155408",
    x1: 741.844,
    y1: 55.1387,
    x2: 741.844,
    y2: 78.3584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint730_linear_136_155408",
    x1: 743.651,
    y1: 57.1836,
    x2: 743.651,
    y2: 79.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint731_linear_136_155408",
    x1: 745.457,
    y1: 59.0352,
    x2: 745.457,
    y2: 79.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint732_linear_136_155408",
    x1: 747.259,
    y1: 60.6582,
    x2: 747.259,
    y2: 80.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint733_linear_136_155408",
    x1: 749.066,
    y1: 62.0449,
    x2: 749.066,
    y2: 80.1983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint734_linear_136_155408",
    x1: 750.872,
    y1: 63.1836,
    x2: 750.872,
    y2: 80.1974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint735_linear_136_155408",
    x1: 752.674,
    y1: 64.0703,
    x2: 752.674,
    y2: 81.0841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B61FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurface);
export default __webpack_public_path__ + "static/media/surface.88e656c5dc3061e8fdb79e18b230e148.svg";
export { ForwardRef as ReactComponent };